import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import {
  Package,
  Clock,
  CheckCircle,
  Truck,
  XCircle,
  DollarSign,
  Users,
  LogOut,
  RefreshCw,
  Boxes,
  Edit3,
  Save,
  X,
  Plus,
  Trash2,
  ImageIcon,
  Warehouse,
  TrendingUp,
  Wallet,
  FileText,
  Printer,
  Home,
  ChevronLeft,
  Search,
  BarChart3,
  CreditCard,
  Megaphone,
  Gift,
  ClipboardList,
  Undo2,
  Receipt,
  ShoppingCart,
  Archive,
  Upload,
  Building2,
  ArrowRight,
  UserCog,
  IdCard,
  Edit2,
  BadgeDollarSign,
  HandCoins,
  ShoppingBag,
  ShieldCheck,
  ShieldQuestion,
  Bell,
  BellOff,
  Coins,
  TrendingDown,
  Car,
  StickyNote,
  ListChecks,
  Inbox,
  Crown,
  Trophy,
  AlertCircle,
  Eye,
  EyeOff,
  History,
  Star,
  UserPlus,
  User,
  Activity,
  AlertTriangle,
  AlarmClock,
  Images,
} from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { fmtMoney } from "../utils/money";
import { toast } from "sonner";
import ProductFormModal from "../components/ProductFormModal";
import AdminAccountsTab from "../components/admin/AdminAccountsTab";
import BrandOffersPickerModal from "../components/admin/BrandOffersPickerModal";
import MonthlyNetProfitModal from "../components/admin/MonthlyNetProfitModal";
import SupplierDebtsTab from "../components/admin/SupplierDebtsTab";
import DriverBundlesTab from "../components/admin/DriverBundlesTab";
import LowStockAlertModal from "../components/admin/LowStockAlertModal";
import AdminNotes from "../components/admin/AdminNotes";
import TileImageEditor from "../components/admin/TileImageEditor";
import BannersManager from "../components/BannersManager";
import InventoryReport from "../components/admin/InventoryReport";
import ProfitsTab from "../components/admin/ProfitsTab";
import WithdrawalsTab from "../components/admin/WithdrawalsTab";
import CustomersTab from "../components/admin/CustomersTab";
import DriversTab from "../components/admin/DriversTab";
import DebtPaymentsTab from "../components/admin/DebtPaymentsTab";
import PaymentConfirmationsTab from "../components/admin/PaymentConfirmationsTab";
import CashSubmissionsTab from "../components/admin/CashSubmissionsTab";
import MujahezTab from "../components/admin/MujahezTab";
import CustomerStatement from "../components/admin/CustomerStatement";
import AccountBalances from "../components/admin/AccountBalances";
import CustomerRewardsReport from "../components/admin/CustomerRewardsReport";
import AddCustomerTab from "../components/admin/AddCustomerTab";
import AdminPoliciesTab from "../components/admin/AdminPoliciesTab";
import CashBoxTab from "../components/admin/CashBoxTab";
import TiersTab from "../components/admin/TiersTab";
import MarketRankingTab from "../components/admin/MarketRankingTab";
import TopMarketsTab from "../components/admin/TopMarketsTab";
import CustomerDetailsTab from "../components/admin/CustomerDetailsTab";
import PendingCustomersTab from "../components/admin/PendingCustomersTab";
import PendingDriverOrdersTab from "../components/admin/PendingDriverOrdersTab";
import AggregatePickListButton from "../components/admin/AggregatePickListButton";
import DailyLogTab from "../components/admin/DailyLogTab";
import DamagedItemsTab from "../components/admin/DamagedItemsTab";
import StaleDebtsTab from "../components/admin/StaleDebtsTab";
import SalesReportTab from "../components/admin/SalesReportTab";
import FinancialActivityTab from "../components/admin/FinancialActivityTab";
import HistoricalStatsBar from "../components/admin/HistoricalStatsBar";
import ReturnsTab from "../components/admin/ReturnsTab";
import ReceiptVoucher from "../components/admin/ReceiptVoucher";
import SalariesTab from "../components/admin/SalariesTab";
import BrandsTab from "../components/admin/BrandsTab";
import CustomerDocsTab from "../components/admin/CustomerDocsTab";
import RepsTab from "../components/admin/RepsTab";
import MandoobsTab from "../components/admin/MandoobsTab";
import AutoBackupsTab from "../components/admin/AutoBackupsTab";
import EmployeesTab from "../components/admin/EmployeesTab";
import EmployeeAdvancesTab from "../components/admin/EmployeeAdvancesTab";
import PurchaseTab, { LowStockModal } from "../components/admin/PurchaseTab";
import SlowMovingProductsTab from "../components/admin/SlowMovingProductsTab";
import SalesInvoicesReportTab from "../components/admin/SalesInvoicesReportTab";
import PurchasesReportTab from "../components/admin/PurchasesReportTab";
import BulkConfirmPrintButton from "../components/admin/BulkConfirmPrintButton";
import MaterialLedgerTab from "../components/admin/MaterialLedgerTab";
import InvoiceEditsLogTab from "../components/admin/InvoiceEditsLogTab";
import DriverRatingsTab from "../components/admin/DriverRatingsTab";
import ProfitChart from "../components/admin/ProfitChart";
import DebtAuditTab from "../components/admin/DebtAuditTab";
import GiftsTab from "../components/admin/GiftsTab";
import DirectSaleTab from "../components/admin/DirectSaleTab";
import PriceListTab from "../components/admin/PriceListTab";
import DriverInvoicesBoard from "../components/admin/DriverInvoicesBoard";
import ManagerLedger from "../components/admin/ManagerLedger";
import PurchaseListTab from "../components/admin/PurchaseListTab";
import ProductPhotosTab from "../components/admin/ProductPhotosTab";
import InventoryCountTab from "../components/admin/InventoryCountTab";
import PurchaseCompaniesTab from "../components/admin/PurchaseCompaniesTab";
import PurchaseProposalsTab from "../components/admin/PurchaseProposalsTab";
import AbPricesTab from "../components/admin/AbPricesTab";
import ComplaintsTab from "../components/admin/ComplaintsTab";
import MoneyBoxTab from "../components/admin/MoneyBoxTab";
import OrderEditModal from "../components/admin/OrderEditModal";
import OrdersProcessingTab from "../components/admin/OrdersProcessingTab";
import SubAdminsTab from "../components/admin/SubAdminsTab";
import MasterProfileModal from "../components/admin/MasterProfileModal";
import WelcomeSplash from "../components/admin/WelcomeSplash";
import SupervisorPriceApprovalsTab from "../components/admin/SupervisorPriceApprovalsTab";
import HRNotesTab from "../components/admin/HRNotesTab";
import HRSummaryStrips from "../components/admin/HRSummaryStrips";
import BellDraftsButton from "../components/admin/BellDraftsButton";
import CustomerHistoryModal from "../components/admin/CustomerHistoryModal";
import SupplierAccountsTab from "../components/admin/SupplierAccountsTab";
import CapitalTab from "../components/admin/CapitalTab";
import ExpensesTab from "../components/admin/ExpensesTab";
import VehiclesTab from "../components/admin/VehiclesTab";
import PendingDraftsBar from "../components/admin/PendingDraftsBar";
import BulkApproveButton from "../components/admin/BulkApproveButton";
import { useDrafts } from "../contexts/DraftsContext";
import PushPermissionButton from "../components/admin/PushPermissionButton";
import InvoiceModal from "../components/InvoiceModal";
import OrderComboActionModal from "../components/admin/OrderComboActionModal";
import { notify, alarmNotify, stopAlarm, onAlarmStart, onAlarmStop, gentleChime, adminVoice } from "../utils/voice";
import { downloadDailyBackup, restoreFullBackup } from "../utils/pdfShare";
import { confirmDialog } from "../utils/confirmDialog";
import { smartMatch } from "../utils/arabicSearch";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const statusConfig = {
  pending: { label: "قيد المعالجة", color: "#F5A623", icon: Clock },
  confirmed: { label: "تم موافقة الطلب", color: "#4A90E2", icon: CheckCircle },
  mujahez_assigned: { label: "بانتظار التجهيز", color: "#9F7AEA", icon: Clock },
  mujahez_preparing: { label: "قيد التجهيز", color: "#3B82F6", icon: Clock },
  ready_for_driver: { label: "جاهز للسائق", color: "#7ED321", icon: CheckCircle },
  assigned: { label: "تم تعيين سائق", color: "#1E3A5F", icon: Truck },
  accepted: { label: "السائق وافق", color: "#1E3A5F", icon: Truck },
  on_the_way: { label: "في الطريق", color: "#E85D45", icon: Truck },
  delivering: { label: "قيد التوصيل", color: "#E85D45", icon: Truck },
  awaiting_payment_confirmation: { label: "بانتظار تأكيد الدفع", color: "#F5A623", icon: Clock },
  delivered: { label: "تم التوصيل", color: "#7ED321", icon: CheckCircle },
  rejected: { label: "مرفوض", color: "#999", icon: XCircle },
};

const TAB_LABELS = {
  home: "الرئيسية",
  orders: "إدارة الطلبات",
  "orders-processing": "معالجة الطلبات",
  "orders-confirmed": "الفواتير المؤكدة",
  "sub-admins": "حسابات إدارية متعددة",
  products: "المنتجات",
  banners: "الإعلانات",
  customers: "الزبائن",
  "customer-docs": "توثيق الزبائن",
  "add-customer": "إضافة زبون جديد",
  reps: "المشرفون",
  mandoobs: "المندوبين",
  drivers: "السائقون",
  mujahez: "المجهّزون",
  inventory: "كشف المخزن",
  "customer-statement": "كشف حساب الزبون",
  "account-balances": "أرصدة الحسابات",
  "supplier-debts": "مديونية الشركات",
  "driver-bundles": "الفواتير مع السواق",
  "customer-rewards": "أرباح الزبائن (المكافآت)",
  profits: "أرباح البرنامج",
  withdrawals: "طلبات السحب",
  debts: "سداد الديون",
  "payment-confirms": "تأكيدات الدفع",
  "cash-subs": "تسليمات السائقين",
  returns: "تعديل القائمة (الإرجاعات)",
  "receipt-voucher": "سند قبض",
  salaries: "رواتب العمال",
  brands: "شركات المنتجات",
  employees: "أرشيف الموظفين",
  "employee-advances": "كشف سلف موظفين",
  purchase: "قائمة الشراء",
  "material-movement": "كشف مادة",
  gifts: "كراتين الهدايا",
  "invoice-edits-log": "سجل تعديلات الفواتير",
  "driver-ratings": "تقييمات السائقين",
  "debt-audit": "تدقيق حسابات الزبائن",
  "direct-sale": "بيع مباشر",
  "price-list": "قائمة الأسعار",
  "cash-box": "صندوق النقد (الكاش)",
  "tiers": "تصنيفات الزبائن (A+ / B+)",
  "market-ranking": "ترتيب الماركتات",
  "top-markets-contest": "الماركتات الأكثر طلباً (سباق شهري)",
  "customer-details": "تفاصيل الزبون",
  "pending-driver-orders": "إغلاق طلبات السواق المعلقة",
  "daily-log": "الحركة اليومية",
  "damaged-items": "تلف مواد",
  "stale-debts": "تنبيهات الديون المتأخرة",
  "sales-report": "تقرير المبيعات والمشتريات",
  "financial-activity": "الحركة المالية اليومية",
  "slow-moving": "المواد المتأخرة بالبيع",
  "sales-invoices-report": "تقارير مبيعات الفواتير",
  "purchases-report": "تقارير مشتريات القوائم",
};

const ADMIN_TILES = [
  { id: "orders", label: "إدارة الطلبات", icon: ClipboardList },
  { id: "orders-processing", label: "معالجة الطلبات", icon: Package },
  { id: "orders-confirmed", label: "الفواتير المؤكدة", icon: CheckCircle },
  { id: "invoice-edits-log", label: "سجل تعديلات الفواتير", icon: History },
  { id: "debt-audit", label: "تدقيق حسابات الزبائن", icon: AlertCircle },
  { id: "returns", label: "تعديل القائمة", icon: Undo2, badge: (b) => b.returns },
  { id: "receipt-voucher", label: "سند قبض", icon: Receipt },
  { id: "salaries", label: "رواتب العمال", icon: Wallet },
  { id: "brands", label: "شركات المنتجات", icon: Building2 },
  // Master-only tile — creating scoped sub-admin accounts.
  { id: "sub-admins", label: "حسابات إدارية متعددة", icon: Users },
  { id: "inventory", label: "كشف المخزن", icon: Warehouse },
  { id: "customer-statement", label: "كشف حساب الزبون", icon: Search },
  { id: "top-markets-contest", label: "الماركتات الأكثر طلباً", icon: Trophy },
  { id: "customer-details", label: "تفاصيل الزبون", icon: User },
  { id: "account-balances", label: "أرصدة الحسابات", icon: CreditCard, badge: (b) => b.account_balances },
  { id: "supplier-debts", label: "مديونية الشركات", icon: Building2 },
  { id: "driver-bundles", label: "الفواتير مع السواق", icon: Truck },
  { id: "customer-rewards", label: "أرباح الزبائن", icon: Gift },
  { id: "profits", label: "أرباح البرنامج", icon: BarChart3 },
  { id: "drivers", label: "السائقون", icon: Truck },
  { id: "driver-ratings", label: "تقييمات السائقين", icon: Star },
  { id: "mujahez", label: "المجهّزون", icon: Package },
  { id: "customers", label: "كل الزبائن", icon: Users },
  { id: "add-customer", label: "إضافة زبون جديد", icon: UserPlus },
  { id: "pending-customers", label: "زبائن قيد الموافقة", icon: ShieldQuestion, badge: (b) => b.pending_customers },
  { id: "customer-docs", label: "توثيق الزبائن", icon: IdCard, badge: (b) => b.inactive_customers },
  { id: "reps", label: "المشرفون", icon: UserCog },
  { id: "mandoobs", label: "المندوبين", icon: UserCog },
  { id: "withdrawals", label: "طلبات السحب", icon: Wallet, badge: (b) => b.withdrawals },
  { id: "debts", label: "سداد الديون", icon: DollarSign, badge: (b) => b.debts },
  { id: "payment-confirms", label: "تأكيدات الدفع", icon: FileText, badge: (b) => b.payments },
  { id: "cash-subs", label: "تسليمات السائقين", icon: Wallet, badge: (b) => b.cash_subs },
  { id: "products", label: "المنتجات", icon: Boxes },
  { id: "banners", label: "الإعلانات", icon: Megaphone },
  { id: "auto-backups", label: "النسخ الآمنة", icon: Archive },
  { id: "policies", label: "السياسات النشطة", icon: ShieldCheck },
  { id: "purchase", label: "قائمة الشراء", icon: ShoppingCart },
  { id: "material-movement", label: "كشف مادة", icon: TrendingUp },
  { id: "gifts", label: "كراتين الهدايا", icon: Gift },
  { id: "supplier-accounts", label: "حسابات المُجهّزين", icon: BadgeDollarSign },
  { id: "purchase-proposals", label: "اقتراحات الشراء", icon: Inbox, badge: (b) => b.purchase_proposals },
  { id: "capital", label: "رأس المال", icon: Coins },
  { id: "admin-accounts", label: "حسابات الإدارة", icon: Wallet },
  { id: "expenses", label: "المصاريف", icon: TrendingDown },
  { id: "vehicles", label: "المركبات", icon: Car },
  { id: "direct-sale", label: "بيع مباشر", icon: ShoppingBag },
  { id: "price-list", label: "قائمة الأسعار", icon: FileText },
  { id: "ab-prices", label: "أسعار A+ و B+", icon: Crown },
  { id: "cash-box", label: "صندوق النقد", icon: Wallet },
  { id: "tiers", label: "تصنيفات الزبائن", icon: Crown },
  { id: "market-ranking", label: "ترتيب الماركتات", icon: Trophy },
  { id: "pending-driver-orders", label: "إغلاق طلبات السواق", icon: Truck, badge: (b) => b.pending_driver_orders },
  { id: "daily-log", label: "الحركة اليومية", icon: Activity },
  { id: "damaged-items", label: "تلف مواد", icon: AlertTriangle },
  { id: "stale-debts", label: "ديون متأخرة", icon: AlertCircle },
  { id: "sales-report", label: "تقرير المبيعات والمشتريات", icon: BarChart3 },
  { id: "financial-activity", label: "الحركة المالية", icon: Wallet },
  { id: "slow-moving", label: "المواد المتأخرة بالبيع", icon: AlarmClock, badge: (b) => b.slow_moving },
  { id: "sales-invoices-report", label: "تقارير مبيعات الفواتير", icon: BarChart3 },
  { id: "purchases-report", label: "تقارير مشتريات القوائم", icon: ShoppingBag },
];

// Group several related child tiles under one ORANGE parent tile.
// Children are hidden from the main grid and only visible after opening the group.
const TILE_GROUPS = [
  {
    id: "orders-customers",
    label: "طلبات الفواتير والزبائن",
    icon: ClipboardList,
    color: "#F5A623", // brand orange
    children: ["orders", "orders-processing", "orders-confirmed", "invoice-edits-log", "debt-audit", "returns", "customers", "add-customer", "pending-customers", "customer-docs", "direct-sale", "cash-subs", "customer-statement", "sales-invoices-report"],
  },
  {
    id: "staff",
    label: "متعلّقات الموظفين",
    icon: Users,
    color: "#F5A623",
    children: ["salaries", "drivers", "driver-ratings", "mujahez", "reps", "mandoobs", "vehicles"],
  },
  {
    id: "finance",
    label: "متعلّقات الأرصدة والديون",
    icon: Wallet,
    color: "#F5A623",
    children: ["receipt-voucher", "account-balances", "payment-confirms", "debts", "capital", "expenses", "cash-box"],
  },
  {
    id: "inventory-purchase",
    label: "متعلّقات الشراء والمواد",
    icon: Boxes,
    color: "#F5A623",
    children: ["brands", "inventory", "products", "purchase", "material-movement", "gifts", "purchase-proposals", "supplier-accounts", "price-list", "ab-prices", "slow-moving", "purchases-report"],
  },
  {
    id: "profits",
    label: "الأرباح",
    icon: BarChart3,
    color: "#F5A623",
    children: ["customer-rewards", "profits", "withdrawals"],
  },
];

// Quick lookup: child tile id → its parent group id
const TILE_PARENT_OF = TILE_GROUPS.reduce((acc, g) => {
  g.children.forEach((cid) => { acc[cid] = g.id; });
  return acc;
}, {});

const TodayStat = ({ icon: Icon, label, value }) => (
  <motion.div
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    data-testid="today-stat-card"
    className="bg-gradient-to-l from-[#1E3A5F] to-[#3B82F6] text-white rounded-2xl p-3 sm:p-4 shadow-md hover:shadow-lg transition-shadow"
  >
    <Icon className="w-5 h-5 mb-1.5 text-white/90" />
    <p className="text-[10px] sm:text-xs text-white/80 leading-tight">{label}</p>
    <p className="font-bold text-base sm:text-lg text-white mt-1" dir="ltr">{value}</p>
  </motion.div>
);

const Admin = () => {
  const navigate = useNavigate();
  const { user, logout, refreshUser } = useAuth();

  // ─── Master / Sub-admin scoping ───────────────────────────────────────
  // Only the master admin (07811557910 / is_master_admin=true) sees the
  // "حسابات إدارية متعددة" tile + can enter that tab. Sub-admins only see
  // the tabs their master granted them via `allowed_tabs`. Added Feb 27, 2026.
  const isMaster = !!(user?.is_master_admin) || user?.phone === "07811557910";
  const isSubAdmin = !!(user?.is_sub_admin);
  const allowedTabs = user?.allowed_tabs || [];
  const canSeeTab = (id) => {
    if (id === "home") return true;
    if (id === "sub-admins") return isMaster;
    if (!isSubAdmin) return true; // regular admin sees everything (except sub-admins if not master, handled above)
    return allowedTabs.includes(id);
  };
  // Home dashboard widget IDs — treated like tabs for permission purposes
  // so master can pick which KPI boxes each sub-admin sees on home.
  const HOME_WIDGET_IDS = [
    "widget-total-sales", "widget-total-received", "widget-total-cartons",
    "widget-orders-done", "widget-orders-pending",
    "widget-cumulative-profit", "widget-capital", "widget-today-sales",
  ];
  const canSeeWidget = (id) => {
    if (!isSubAdmin) return true;
    return allowedTabs.includes(id);
  };
  // Portal-switcher icons (view as Customer / Driver / Mujahez / Rep / Complaints).
  // Same permission model as widgets — sub-admin only sees the portals master granted.
  const canSeePortal = (id) => {
    if (!isSubAdmin) return true;
    return allowedTabs.includes(id);
  };
  const VISIBLE_TILES = ADMIN_TILES.filter((t) => canSeeTab(t.id));
  const VISIBLE_GROUPS = TILE_GROUPS
    .map((g) => ({ ...g, children: g.children.filter((cid) => canSeeTab(cid)) }))
    .filter((g) => g.children.length > 0);
  const VISIBLE_TILE_PARENT_OF = VISIBLE_GROUPS.reduce((acc, g) => {
    g.children.forEach((cid) => { acc[cid] = g.id; });
    return acc;
  }, {});
  // ────────────────────────────────────────────────────────────────────

  const [orders, setOrders] = useState([]);
  const [stats, setStats] = useState(null);
  // Persistent eye-toggle. When ON every money/quantity value on the admin
  // home is masked as "•••" — data is NEVER deleted, only hidden from view.
  const [hideAmounts, setHideAmounts] = useState(() => {
    try { return localStorage.getItem("admin_hide_amounts") === "1"; }
    catch (_) { return false; }
  });
  const toggleHideAmounts = () => {
    setHideAmounts((v) => {
      const next = !v;
      try { localStorage.setItem("admin_hide_amounts", next ? "1" : "0"); } catch (_) { /* storage blocked */ }
      return next;
    });
  };
  // Tiny helper that masks any money/qty value when the eye is closed.
  // Keeps the unit suffix readable so the layout doesn't jump.
  const maskVal = (val) => (hideAmounts ? "•••" : val);
  const [capital, setCapital] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  // Compact-vs-cards toggle + day-offset navigation. 0 = today,
  // 1 = yesterday, etc. Used on the orders/confirmed tabs.
  const [ordersView, setOrdersView] = useState("compact"); // 'compact' | 'cards'
  // Aggregate pick-list selection state (Feb 17, 2026 — for the
  // "الفواتير المؤكدة" tab). When selectMode=true the compact rows show
  // a checkbox; selecting multiple orders and pressing the print button
  // opens an aggregated pick-list ready for the warehouse.
  const [picklistSelectMode, setPicklistSelectMode] = useState(false);
  const [picklistSelectedIds, setPicklistSelectedIds] = useState([]);
  const togglePicklistId = (id) => {
    setPicklistSelectedIds((prev) => prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]);
  };
  const [dayOffset, setDayOffset] = useState(0);
  const [compactDetailOrderId, setCompactDetailOrderId] = useState(null);
  // Orders search & date filtering
  const [orderSearch, setOrderSearch] = useState("");
  // Server-side search hits — populated when `orderSearch` is used and
  // may include invoices older than the default 500-doc window returned
  // by /admin/orders. Merged into the main list when active.
  const [orderSearchHits, setOrderSearchHits] = useState([]);
  const [orderDateFilter, setOrderDateFilter] = useState("all"); // all | today | range
  const [orderDateFrom, setOrderDateFrom] = useState(""); // YYYY-MM-DD
  const [orderDateTo, setOrderDateTo] = useState("");     // YYYY-MM-DD
  // Inline editing of order item prices
  const [editingOrderItem, setEditingOrderItem] = useState(null); // {orderId, productId}
  const [editItemPrice, setEditItemPrice] = useState("");
  // Order IDs whose customer-note popover is currently expanded (sky-blue button)
  const [openNoteOrderId, setOpenNoteOrderId] = useState(null);
  // Inline editing of order item quantities
  const [editingOrderItemQty, setEditingOrderItemQty] = useState(null); // {orderId, productId}
  const [editItemQty, setEditItemQty] = useState("");
  // Top-of-page invoice quick-search
  const [globalInvoiceSearch, setGlobalInvoiceSearch] = useState("");
  const [showInvoiceResults, setShowInvoiceResults] = useState(false);

  // Auto-show invoice search dropdown as soon as user types
  useEffect(() => {
    setShowInvoiceResults(globalInvoiceSearch.trim().length > 0);
  }, [globalInvoiceSearch]);
  const [activeTab, setActiveTabRaw] = useState("home"); // home | orders | products | ...
  const draftsCtx = useDrafts();
  const setActiveTab = (target) => {
    if (target === activeTab) return;
    // Guard: sub-admin cannot navigate to a tab outside their allowed list.
    if (!canSeeTab(target)) {
      toast.error("ما عندك صلاحية للدخول لهذا القسم");
      return;
    }
    const blocked = draftsCtx.confirmSwitch(activeTab, target, () => setActiveTabRaw(target));
    if (!blocked) setActiveTabRaw(target);
  };
  const [showTileMenu, setShowTileMenu] = useState(false);
  const [showMonthlyNetProfit, setShowMonthlyNetProfit] = useState(false);
  // Alarm state — drives the floating "إيقاف الإنذار" button shown while a
  // siren is playing. The voice util fires the start/stop callbacks.
  const [alarmActive, setAlarmActive] = useState(false);
  useEffect(() => {
    onAlarmStart(() => setAlarmActive(true));
    onAlarmStop(() => setAlarmActive(false));
  }, []);
  const [activeGroupId, setActiveGroupId] = useState(null);
  const [showMasterProfile, setShowMasterProfile] = useState(false);
  // Welcome splash — sub-admins ONLY (owner's request Feb 27, 2026 — the
  // master never sees it, even if he sets a welcome_text/audio for himself).
  const [showWelcomeSplash, setShowWelcomeSplash] = useState(false);
  // After the splash closes, we mount the admin content with a staggered
  // "reveal" animation on every icon/tile — inspired by the eDEX-UI intro
  // video the owner shared. This flag drives the AnimatePresence key.
  const [iconsRevealed, setIconsRevealed] = useState(false);
  useEffect(() => {
    if (!user) return;
    const seenKey = `welcome_seen_${user.id || user.phone}`;
    if (sessionStorage.getItem(seenKey)) { setIconsRevealed(true); return; }
    // Sub-admins only.
    if (user.is_sub_admin) {
      setShowWelcomeSplash(true);
      sessionStorage.setItem(seenKey, "1");
    } else {
      setIconsRevealed(true); // master → skip splash entirely
    }
  }, [user]);
  // Tile image customization: {tile_id: {image_path, size}}
  const [tileImages, setTileImages] = useState({});
  const [tileImageEditor, setTileImageEditor] = useState(null); // {tile_id, label} or null
  const [editingProduct, setEditingProduct] = useState(null);
  const [editStock, setEditStock] = useState("");
  const [categories, setCategories] = useState([]);
  const [showProductForm, setShowProductForm] = useState(false);
  const [historyQuery, setHistoryQuery] = useState(null); // { initial: "phone:07..." } or null
  // Manager (07858877756) can temporarily peek the full admin dashboard.
  // Stored in sessionStorage so refresh inside this session preserves the view,
  // but a fresh login defaults back to the HR portal.
  const [peekAdmin, setPeekAdmin] = useState(() => {
    try { return sessionStorage.getItem("hr_peek_admin") === "1"; } catch { return false; }
  });
  const togglePeekAdmin = (on) => {
    setPeekAdmin(on);
    try { sessionStorage.setItem("hr_peek_admin", on ? "1" : "0"); } catch {}
  };
  const [productToEdit, setProductToEdit] = useState(null);
  const [productFilter, setProductFilter] = useState("all"); // all | offer | bestseller | win
  // Products tab — brand-first navigation
  const [productsBrands, setProductsBrands] = useState([]); // all brands across all categories
  const [productsBrandSearch, setProductsBrandSearch] = useState("");
  // 🔍 Precise Arabic-tolerant search on the products list INSIDE a brand.
  // Kept in state per-brand session so switching brands resets it.
  const [productsInBrandSearch, setProductsInBrandSearch] = useState("");
  const [selectedProductBrand, setSelectedProductBrand] = useState(null); // {id, name_ar, category} or {id:'__none__'} for orphans
  // Feb 2026: low-stock alert modal — opened from within a brand's product
  // detail view, produces a shareable "shortage invoice" list.
  const [lowStockBrand, setLowStockBrand] = useState(null);

  // Reset the in-brand product search whenever the admin switches brands
  // (or leaves the brand view) — otherwise stale query filters a new brand.
  useEffect(() => {
    setProductsInBrandSearch("");
  }, [selectedProductBrand?.id]);
  const [preselectedBrandForNew, setPreselectedBrandForNew] = useState(null);
  // Bump counter — incremented whenever ANY product is created / edited /
  // deleted so screens that hold their own product list (like the
  // Inventory Report and Material Ledger) can refresh in real time
  // instead of relying on the admin remounting the tab manually.
  const [productsChangedTick, setProductsChangedTick] = useState(0);
  const bumpProductsChanged = () => setProductsChangedTick((t) => t + 1);
  // Bulk-add mode: when true, ProductFormModal keeps itself open after save
  // and resets to a fresh form so the admin can hammer through many products
  // in one session. Closed only when the admin taps ✕. Requested Feb 27, 2026.
  const [bulkAddMode, setBulkAddMode] = useState(false);
  // Track in-progress bulk brand-offer toggles so buttons don't double-fire.
  const [brandOfferBusy, setBrandOfferBusy] = useState(false);
  // Brand offers picker modal — tap-to-toggle per-product offer selector.
  const [offersPickerBrand, setOffersPickerBrand] = useState(null);
  const [pendingWithdrawals, setPendingWithdrawals] = useState(0);
  const [pendingDebtPayments, setPendingDebtPayments] = useState(0);
  const [pendingPaymentConfirms, setPendingPaymentConfirms] = useState(0);
  const [pendingCashSubmissions, setPendingCashSubmissions] = useState(0);
  const [pendingReturns, setPendingReturns] = useState(0);
  const [pendingPurchaseProposals, setPendingPurchaseProposals] = useState(0);
  const [slowMovingCount, setSlowMovingCount] = useState(0);
  const [pendingCustomersCount, setPendingCustomersCount] = useState(0);
  const [lowStockCount, setLowStockCount] = useState(0);
  const [showLowStock, setShowLowStock] = useState(false);
  const [complaintsUnreadCount, setComplaintsUnreadCount] = useState(0);
  const [moneyBoxPendingCount, setMoneyBoxPendingCount] = useState(0);
  const [supPriceApprovalsPending, setSupPriceApprovalsPending] = useState(0);
  const [editingOrderForItems, setEditingOrderForItems] = useState(null);
  const [purchasePresetProductIds, setPurchasePresetProductIds] = useState([]);
  const [invoiceOrder, setInvoiceOrder] = useState(null);
  const [comboOrder, setComboOrder] = useState(null);
  // Live customer debt used by the print receipt. Fetched whenever the
  // invoice modal opens — never reuse the order's stale snapshot since the
  // ledger may have moved on (extra orders, manual adjustments, receipt
  // vouchers, etc.).
  const [invoiceCustomerDebt, setInvoiceCustomerDebt] = useState(0);
  useEffect(() => {
    if (!invoiceOrder) { setInvoiceCustomerDebt(0); return; }
    const fetchDebt = async () => {
      const phone = invoiceOrder.user_phone || "";
      const cid = invoiceOrder.customer_id || "";
      const q = (phone || cid || invoiceOrder.user_name || "").toString().trim();
      if (!q) { setInvoiceCustomerDebt(0); return; }
      try {
        const { data } = await axios.get(`${API}/admin/customer-lookup`, { params: { q } });
        const match =
          (Array.isArray(data) && data.find((u) => u.id === cid)) ||
          (Array.isArray(data) && data.find((u) => u.phone === phone)) ||
          (Array.isArray(data) && data[0]);
        setInvoiceCustomerDebt(Number(match?.customer_debt || 0));
      } catch (_) { setInvoiceCustomerDebt(0); }
    };
    fetchDebt();
  }, [invoiceOrder]);
  const [availableDrivers, setAvailableDrivers] = useState([]);
  const [availableMujahez, setAvailableMujahez] = useState([]);
  const prevPendingOrdersRef = useRef(null);
  // When a new pending order arrives, ring (shake) the bell for 6 seconds
  const [newOrderRing, setNewOrderRing] = useState(false);
  const newOrderRingTimerRef = useRef(null);
  const prevPendingConfirmsRef = useRef(null);
  const prevDriversCountRef = useRef(null);
  const prevMujahezCountRef = useRef(null);
  const prevWithdrawalsRef = useRef(null);
  const prevDebtPaymentsRef = useRef(null);
  const prevReturnsRef = useRef(null);
  const prevCashSubsRef = useRef(null);

  // Listen for AI assistant requests to open a specific admin tab
  useEffect(() => {
    const onOpen = (e) => {
      const tab = e.detail?.tab;
      if (!tab) return;
      // map common aliases the AI might use
      const aliases = {
        "receipts": "receipt-voucher",
        "receipt": "receipt-voucher",
        "cash": "cash-subs",
      };
      const target = aliases[tab] || tab;
      setActiveTab(target);
      setShowTileMenu(false);
    };
    window.addEventListener("ai-open-admin-tab", onOpen);
    return () => window.removeEventListener("ai-open-admin-tab", onOpen);
  }, []);

  // Load brands when products tab is opened (or brand search changes)
  const fetchProductsBrands = async () => {
    try {
      const { data } = await axios.get(`${API}/admin/brands`);
      setProductsBrands(data || []);
    } catch (e) {
      // silent
    }
  };
  useEffect(() => {
    if (activeTab === "products") {
      fetchProductsBrands();
      // reset selection whenever we enter the tab fresh
      setSelectedProductBrand(null);
      setProductsBrandSearch("");
    }
    // Reset the status filter when jumping between "orders" (pending) and
    // "orders-confirmed" (approved) — keeps each tab in a sensible default.
    if (activeTab === "orders" || activeTab === "orders-confirmed") {
      setFilter("all");
    }
  }, [activeTab]); // eslint-disable-line

  // ── Server-side order search ──
  // When the admin types a query on the orders tab, hit /admin/orders?q=X
  // so we can find invoices older than the default 500-doc window
  // (feature-request Feb 2026: "بس اكتب الرقم مالتها تطلع لي").
  useEffect(() => {
    const q = (orderSearch || "").trim();
    if (q.length < 2) {
      setOrderSearchHits([]);
      return;
    }
    const t = setTimeout(async () => {
      try {
        const { data } = await axios.get(`${API}/admin/orders`, { params: { q } });
        setOrderSearchHits(Array.isArray(data) ? data : []);
      } catch {
        // silent — the client-side filter still works on the loaded 500
      }
    }, 350);
    return () => clearTimeout(t);
  }, [orderSearch]);

  const fetchData = async () => {
    try {
      const [ordersRes, statsRes, productsRes, catsRes, wdRes, dpRes, pcRes, drvRes, csRes, mzRes, rtRes, tiRes, capRes] = await Promise.all([
        axios.get(`${API}/admin/orders`),
        axios.get(`${API}/admin/stats`),
        axios.get(`${API}/admin/products`),
        axios.get(`${API}/categories`),
        axios.get(`${API}/admin/withdrawals?status=pending`).catch(() => ({ data: [] })),
        axios.get(`${API}/admin/debt-payments?status=pending`).catch(() => ({ data: [] })),
        axios.get(`${API}/admin/payment-confirmations`).catch(() => ({ data: [] })),
        axios.get(`${API}/admin/drivers`).catch(() => ({ data: [] })),
        axios.get(`${API}/admin/cash-submissions?status=pending`).catch(() => ({ data: [] })),
        axios.get(`${API}/admin/mujahez`).catch(() => ({ data: [] })),
        axios.get(`${API}/admin/returns?status=pending`).catch(() => ({ data: [] })),
        axios.get(`${API}/admin/tile-images`).catch(() => ({ data: {} })),
        axios.get(`${API}/admin/capital`).catch(() => ({ data: null })),
      ]);
      setTileImages(tiRes.data || {});
      setCapital(capRes.data);

      // Voice notifications when counts increase
      // NOTE (Feb 27, 2026): supervisor invoices awaiting admin confirmation
      // also count as «pending» visually so the bell rings for them too.
      const newPendingOrders = ordersRes.data.filter(
        (o) => o.status === "pending" || (o.awaiting_admin_confirmation && o.is_supervisor_sale)
      ).length;
      const newPendingConfirms = pcRes.data.length || 0;
      const newDriversCount = (drvRes.data || []).length;
      const newMujahezCount = (mzRes.data || []).length;
      const newWithdrawalsCount = wdRes.data.length || 0;
      const newDebtPaymentsCount = dpRes.data.length || 0;
      const newReturnsCount = rtRes.data.length || 0;
      const newCashSubsCount = csRes.data.length || 0;

      if (prevPendingOrdersRef.current !== null && newPendingOrders > prevPendingOrdersRef.current) {
        // Calm chime instead of the loud air-raid siren (per admin request).
        gentleChime();
        notify(adminVoice.newOrder);
        try { toast.info("🛒 إجاكم طلب جديد", { duration: 5000 }); } catch (e) { /* ignore */ }
        // Trigger the shaking-bell visual alert for 10 seconds (longer for new orders)
        setNewOrderRing(true);
        if (newOrderRingTimerRef.current) clearTimeout(newOrderRingTimerRef.current);
        newOrderRingTimerRef.current = setTimeout(() => setNewOrderRing(false), 10000);
      }
      if (prevPendingConfirmsRef.current !== null && newPendingConfirms > prevPendingConfirmsRef.current) {
        notify(adminVoice.paymentConfirmation);
        try { toast.info("💳 طلب تأكيد استلام مبلغ جديد"); } catch (e) { /* ignore */ }
      }
      if (prevDriversCountRef.current !== null && newDriversCount > prevDriversCountRef.current) {
        notify(adminVoice.newDriver);
        try { toast.info("🚚 سائق جديد سجّل في النظام"); } catch (e) { /* ignore */ }
      }
      if (prevMujahezCountRef.current !== null && newMujahezCount > prevMujahezCountRef.current) {
        notify(adminVoice.newMujahez);
        try { toast.info("📦 مجهّز جديد سجّل في النظام"); } catch (e) { /* ignore */ }
      }
      if (prevWithdrawalsRef.current !== null && newWithdrawalsCount > prevWithdrawalsRef.current) {
        notify(adminVoice.newWithdrawal);
        try { toast.info("💰 طلب سحب أرباح جديد"); } catch (e) { /* ignore */ }
      }
      if (prevDebtPaymentsRef.current !== null && newDebtPaymentsCount > prevDebtPaymentsRef.current) {
        notify(adminVoice.newDebtPayment);
        try { toast.info("💵 طلب تسديد دين جديد"); } catch (e) { /* ignore */ }
      }
      if (prevReturnsRef.current !== null && newReturnsCount > prevReturnsRef.current) {
        notify(adminVoice.newReturn);
        try { toast.info("↩️ طلب إرجاع جديد"); } catch (e) { /* ignore */ }
      }
      if (prevCashSubsRef.current !== null && newCashSubsCount > prevCashSubsRef.current) {
        notify(adminVoice.newCashSubmission);
        try { toast.info("💼 تسليم نقد من السائق"); } catch (e) { /* ignore */ }
      }

      prevPendingOrdersRef.current = newPendingOrders;
      prevPendingConfirmsRef.current = newPendingConfirms;
      prevDriversCountRef.current = newDriversCount;
      prevMujahezCountRef.current = newMujahezCount;
      prevWithdrawalsRef.current = newWithdrawalsCount;
      prevDebtPaymentsRef.current = newDebtPaymentsCount;
      prevReturnsRef.current = newReturnsCount;
      prevCashSubsRef.current = newCashSubsCount;

      setOrders(ordersRes.data);
      setStats(statsRes.data);
      setProducts(productsRes.data);
      setCategories(catsRes.data);
      setPendingWithdrawals(wdRes.data.length || 0);
      setPendingDebtPayments(dpRes.data.length || 0);
      setPendingPaymentConfirms(newPendingConfirms);
      setPendingCashSubmissions(csRes.data.length || 0);
      setPendingReturns(rtRes.data.length || 0);
      // Fetch pending purchase proposals count (manager → admin)
      try {
        const ppRes = await axios.get(`${API}/admin/purchase-proposals/count-pending`);
        setPendingPurchaseProposals(ppRes.data?.pending || 0);
      } catch { /* non-fatal */ }
      // Fetch slow-moving products count (products with no sales in last 7 days)
      try {
        const smRes = await axios.get(`${API}/admin/slow-moving-products?days=7`);
        setSlowMovingCount(smRes.data?.count || 0);
      } catch { /* non-fatal */ }
      // Fetch pending customers awaiting admin approval (added by supervisors)
      try {
        const pcRes = await axios.get(`${API}/admin/pending-customers`);
        setPendingCustomersCount(Array.isArray(pcRes.data) ? pcRes.data.length : 0);
      } catch { /* non-fatal */ }
      setAvailableDrivers(drvRes.data || []);
      setAvailableMujahez(mzRes.data || []);
    } catch (err) {
      if (err.response?.status === 403) {
        toast.error("ليس لديك صلاحية الوصول");
        navigate("/");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user?.role !== "admin") {
      navigate("/login");
      return;
    }
    // Employees-only admin: skip the full admin data poll
    if (user?.is_employees_only) {
      setLoading(false);
      return;
    }
    // Only poll the heavy admin dataset when the admin is on a tab that
    // actually uses this data (home dashboard, orders board, confirmed
    // orders board). On other tabs (Direct Sale, Customer Statement,
    // Products, etc.) the poll is skipped entirely so those tabs' own
    // fetches don't wait behind ~16 background poll requests — which on
    // a slow Iraqi Wi-Fi connection was making tab-switch appear to
    // "hang for 2-4 minutes".
    const needsPoll = ["home", "orders", "orders-confirmed"].includes(activeTab);
    if (!needsPoll) return;

    // Also skip the poll while the browser tab is in the background —
    // silences useless traffic when the admin is doing something else.
    const shouldSkipHidden = () => typeof document !== "undefined" && document.hidden;

    const tick = () => { if (!shouldSkipHidden()) fetchData(); };
    tick();
    // Slower poll (20s instead of 10s) reduces the total request count
    // by half while keeping the notification bell reasonably fresh.
    const interval = setInterval(tick, 20000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, navigate, activeTab]);

  // Low-stock poll for the bell badge — 60s (was 30s). This is only a
  // count for the header badge; it doesn't need to be near-realtime.
  useEffect(() => {
    if (user?.role !== "admin" || user?.is_employees_only) return;
    const fetchLowStock = async () => {
      if (typeof document !== "undefined" && document.hidden) return;
      try {
        const { data } = await axios.get(`${API}/admin/low-stock`);
        setLowStockCount(data?.count || 0);
      } catch { /* silent */ }
    };
    fetchLowStock();
    const id = setInterval(fetchLowStock, 60000);
    return () => clearInterval(id);
  }, [user]);

  // Complaints unread count poll — 60s (was 20s). Small count query.
  useEffect(() => {
    if (user?.role !== "admin" || user?.is_employees_only) return;
    const fetchUnread = async () => {
      if (typeof document !== "undefined" && document.hidden) return;
      try {
        const { data } = await axios.get(`${API}/admin/complaints/count-unread`);
        setComplaintsUnreadCount(data?.count || 0);
      } catch { /* silent */ }
    };
    fetchUnread();
    const id = setInterval(fetchUnread, 60000);
    return () => clearInterval(id);
  }, [user]);

  // Money-Box pending count poll — 60s (was 15s). Small count query.
  useEffect(() => {
    if (user?.role !== "admin" || user?.is_employees_only) return;
    const fetchMb = async () => {
      if (typeof document !== "undefined" && document.hidden) return;
      try {
        const { data } = await axios.get(`${API}/admin/money-box/count-pending`);
        setMoneyBoxPendingCount(data?.count || 0);
      } catch { /* silent */ }
    };
    fetchMb();
    const id = setInterval(fetchMb, 60000);
    return () => clearInterval(id);
  }, [user]);

  // Supervisor price-approval pending count (drives the orange shield badge)
  useEffect(() => {
    if (user?.role !== "admin" || user?.is_employees_only) return;
    const fetchSp = async () => {
      if (typeof document !== "undefined" && document.hidden) return;
      try {
        const { data } = await axios.get(`${API}/admin/supervisor-price-approvals/count-pending`);
        setSupPriceApprovalsPending(data?.count || 0);
      } catch { /* silent */ }
    };
    fetchSp();
    const id = setInterval(fetchSp, 60000);
    return () => clearInterval(id);
  }, [user]);

  const updateStatus = async (orderId, status) => {
    try {
      await axios.patch(`${API}/admin/orders/${orderId}`, { status });
      toast.success("تم تحديث حالة الطلب");
      fetchData();
    } catch {
      toast.error("فشل التحديث");
    }
  };

  // One-click cancel-and-revert. Sets status to "rejected" which (server-side):
  //   • restores deducted product stock
  //   • refunds the not-yet-paid debt portion to the customer
  //   • claws back rewards earned
  //   • profit calculation already EXCLUDES rejected orders
  const cancelOrder = async (order) => {
    const ok = await confirmDialog(
      `إلغاء الطلب #${order.__seq ?? (order.id || "").slice(0,8)} للزبون «${order.user_name || ""}»؟\n\n` +
      `سيتم تلقائياً:\n• إرجاع الكميات للمخزون\n• حذف الربح\n• خصم المديونية من الزبون\n• سحب نقاط المكافآت\n\nهذا الإجراء قابل للتراجع بإعادة الحالة لاحقاً.`
    );
    if (!ok) return;
    try {
      await axios.patch(`${API}/admin/orders/${order.id}`, { status: "rejected" });
      toast.success("تم إلغاء الطلب وإرجاع الكميات");
      fetchData();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "فشل الإلغاء");
    }
  };

  // Permanent delete — removes the order entirely from the admin's view.
  // Distinct from "reject" which only flips status. Customer account is NOT
  // touched; stock/debt/rewards side-effects are rolled back server-side.
  const permanentDeleteOrder = async (order) => {
    const ok = await confirmDialog(
      `حذف الفاتورة #${order.__seq ?? (order.id || "").slice(0,8)} نهائياً من السجل؟\n\n` +
      `سترجع البضاعة (${(order.items || []).reduce((s, it) => s + (it.quantity || 0), 0)} كرتون) إلى المخزن تلقائياً.\n` +
      `لن يتم حذف الزبون نفسه.\n\nهذا الإجراء لا يمكن التراجع عنه.`,
      { force: true, tone: "danger", title: "تأكيد حذف نهائي", confirmLabel: "نعم، احذف نهائياً", cancelLabel: "إلغاء" }
    );
    if (!ok) return;
    try {
      await axios.delete(`${API}/admin/orders/${order.id}`);
      toast.success("تم حذف الطلب نهائياً وإرجاع البضاعة للمخزن");
      fetchData();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "فشل الحذف");
    }
  };

  // Soft-hide an invoice from the confirmed-board only. Stock/debt stay
  // intact. Customer can still find it later via search.
  const hideOrder = async (order) => {
    const ok = await confirmDialog(
      `إخفاء الفاتورة #${order.__seq ?? (order.id || "").slice(0,8)} من اللوحة فقط؟\n\n` +
      `لن يتم حذفها من النظام، فقط تختفي من قائمة الفواتير المؤكدة.\nالبضاعة لا ترجع للمخزن وحساب الزبون لا يتغير.\nتقدر تبحث عنها لاحقاً برقم الفاتورة أو اسم الزبون.`
    );
    if (!ok) return;
    try {
      await axios.patch(`${API}/admin/orders/${order.id}/hide`);
      toast.success("تم إخفاء الفاتورة من اللوحة");
      fetchData();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "فشل الإخفاء");
    }
  };

  // ─── Bulk hide all currently-visible invoices in the active tab ───
  // Asked by admin on Feb 27, 2026: "I forgot day after day → ~155 confirmed
  // invoices piled up; I don't want to click hide on each one." Now one
  // button hides every visible invoice in the tab (stock/debt untouched).
  //
  // 🛡️ SAFETY (Jul 5, 2026): On the «طلبات معلّقة» tab we EXCLUDE any invoice
  // whose status is still `pending` OR that's a supervisor sale awaiting admin
  // confirmation — those are ACTIVE customer orders that must NOT disappear
  // from the board. Only REJECTED invoices get hidden from this bucket.
  // Root cause: an admin clicked this button while brand-new pending orders
  // were visible → the new orders got hidden and admin thought they never
  // arrived. Never again.
  const hideAllOrders = async () => {
    const scope = activeTab === "orders-confirmed" ? "confirmed" : "pending";
    let candidates = filteredOrders;
    let protectedCount = 0;
    if (scope === "pending") {
      protectedCount = candidates.filter(
        (o) => o.status === "pending" || (o.awaiting_admin_confirmation && o.is_supervisor_sale)
      ).length;
      candidates = candidates.filter(
        (o) => o.status !== "pending" && !(o.awaiting_admin_confirmation && o.is_supervisor_sale)
      );
    }
    const visible = candidates.length;
    if (visible === 0) {
      if (protectedCount > 0) {
        toast.info(`لا يمكن إخفاء ${protectedCount} فاتورة معلّقة — يجب معالجتها أولاً (تأكيد أو رفض)`);
      } else {
        toast.info("ما عدنا فواتير ظاهرة للإخفاء");
      }
      return;
    }
    const label = scope === "confirmed" ? "الفواتير المؤكدة" : "الفواتير المرفوضة";
    const extraNote = protectedCount > 0
      ? `\n\n🛡️ ${protectedCount} فاتورة معلّقة (Pending) لن تُخفى — يجب معالجتها أولاً.`
      : "";
    const ok = await confirmDialog(
      `إخفاء ${visible} فاتورة من «${label}» من اللوحة دفعة واحدة؟\n\n` +
      `• البضاعة لا ترجع للمخزن.\n• حسابات الزبائن ما تتغيّر.\n• الفواتير تبقى محفوظة وقابلة للبحث.` +
      extraNote
    );
    if (!ok) return;
    try {
      // Send the explicit list of visible IDs so the action stays scoped to
      // what the admin actually sees (respects search/date filters + the
      // safety filter above that protects active pending orders).
      const ids = candidates.map((o) => o.id);
      const { data } = await axios.post(`${API}/admin/orders/bulk-hide`, { ids, scope });
      toast.success(data?.message || `تم الإخفاء (${data?.hidden ?? 0})`);
      fetchData();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "فشل الإخفاء الجماعي");
    }
  };

  // ─── Admin confirms a supervisor-created invoice ───
  // Moves it from «Pending/Unconfirmed» into «Confirmed Invoices». No
  // stock/debt/profit change — those were applied at creation.
  const confirmSupervisorSale = async (order) => {
    try {
      await axios.patch(`${API}/admin/orders/${order.id}/confirm-supervisor-sale`);
      toast.success("تم تأكيد الفاتورة");
      fetchData();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "فشل التأكيد");
    }
  };

  const confirmAllSupervisorSales = async () => {
    const visibleAwaiting = filteredOrders.filter((o) => o.awaiting_admin_confirmation);
    if (visibleAwaiting.length === 0) {
      toast.info("ما عدنا فواتير مشرف بانتظار التأكيد");
      return;
    }
    const ok = await confirmDialog(`تأكيد ${visibleAwaiting.length} فاتورة مشرف دفعة واحدة؟`);
    if (!ok) return;
    try {
      const ids = visibleAwaiting.map((o) => o.id);
      const { data } = await axios.post(`${API}/admin/orders/bulk-confirm-supervisor-sales`, { ids });
      toast.success(data?.message || `تم التأكيد (${data?.confirmed ?? 0})`);
      fetchData();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "فشل التأكيد الجماعي");
    }
  };

  const handleSaveStock = async (productId) => {
    const newStock = parseInt(editStock, 10);
    if (isNaN(newStock) || newStock < 0) {
      toast.error("الكمية يجب أن تكون رقماً صحيحاً");
      return;
    }
    try {
      await axios.patch(`${API}/admin/products/${productId}/stock`, { stock: newStock });
      toast.success("تم تحديث الكمية المتوفرة");
      setEditingProduct(null);
      setEditStock("");
      fetchData();
    } catch {
      toast.error("فشل تحديث الكمية");
    }
  };

  const handleDeleteProduct = async (productId, productName) => {
    if (!(await confirmDialog(`هل أنت متأكد من حذف "${productName}"؟`))) return;
    try {
      await axios.delete(`${API}/admin/products/${productId}`);
      toast.success("تم حذف المنتج");
      fetchData();
    } catch {
      toast.error("فشل حذف المنتج");
    }
  };

  const assignDriver = async (orderId, driverId) => {
    try {
      await axios.patch(`${API}/admin/orders/${orderId}/assign`, { driver_id: driverId });
      toast.success("تم تعيين السائق");
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "فشل التعيين");
    }
  };

  const assignMujahez = async (orderId, mujahezId, discount = 0) => {
    try {
      const body = { mujahez_id: mujahezId };
      if (discount && discount > 0) body.discount = Number(discount);
      const { data } = await axios.patch(`${API}/admin/orders/${orderId}/assign-mujahez`, body);
      toast.success(data.message || "تم تعيين المجهّز");
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "فشل التعيين");
    }
  };

  // Mujahez-assign modal: shows the list of available mujahez + an
  // OPTIONAL "خصم مبلغ" field. Admin-only — the supervisor and driver
  // do NOT see this. Discount reduces order total, customer debt, AND
  // app profit (revenue drops by the discount amount).
  const [assignModal, setAssignModal] = useState(null); // { orderId, orderTotal }
  const [assignMujahezId, setAssignMujahezId] = useState("");
  const [assignDiscount, setAssignDiscount] = useState("");
  const submitAssignModal = async () => {
    if (!assignMujahezId) { toast.error("اختر مجهّزاً"); return; }
    const disc = parseFloat(assignDiscount) || 0;
    if (disc < 0) { toast.error("الخصم لا يصير سالب"); return; }
    if (assignModal && disc > (assignModal.orderTotal || 0)) {
      toast.error(`الخصم أكبر من قيمة الفاتورة (${Number(assignModal.orderTotal).toLocaleString("en-US")} د.ع)`);
      return;
    }
    await assignMujahez(assignModal.orderId, assignMujahezId, disc);
    setAssignModal(null);
    setAssignMujahezId("");
    setAssignDiscount("");
  };


  const handleSaveOrderItemPrice = async (orderId, productId) => {
    const newPrice = parseFloat(editItemPrice);
    if (isNaN(newPrice) || newPrice < 0) {
      toast.error("السعر يجب أن يكون رقماً صحيحاً");
      return;
    }
    // Below-cost protection: lookup the product in the global inventory
    // (`products` state) and warn before saving if the new price < cost_price.
    const prod = products.find((p) => p.id === productId);
    const cost = Number(prod?.cost_price || 0);
    if (cost > 0 && newPrice < cost) {
      const ok = await confirmDialog(
        `⚠️ تنبيه: سعر البيع (${Number(newPrice).toLocaleString("en-US")} د.ع) أقل من سعر الشراء (${Number(cost).toLocaleString("en-US")} د.ع).\n\nسيتسبب بخسارة على هذه المادة. هل تريد المتابعة؟`
      );
      if (!ok) return;
    }
    try {
      const { data } = await axios.patch(
        `${API}/admin/orders/${orderId}/items/${productId}`,
        { price: newPrice }
      );
      toast.success(`تم تحديث السعر — الفرق: ${Number(data.delta || 0).toLocaleString("en-US")} د.ع`);
      setEditingOrderItem(null);
      setEditItemPrice("");
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "فشل تحديث السعر");
    }
  };

  const handleSaveOrderItemQty = async (orderId, productId) => {
    const newQty = parseInt(editItemQty, 10);
    if (isNaN(newQty) || newQty < 1) {
      toast.error("الكمية يجب أن تكون 1 أو أكثر");
      return;
    }
    // Negative-stock protection: compute the delta vs the current order line.
    // If the increase exceeds available stock, block the action with a clear
    // alert so the operator can't oversell what isn't physically in stock.
    const order = orders.find((o) => o.id === orderId);
    const currentItem = order?.items?.find((it) => it.product_id === productId);
    const oldQty = Number(currentItem?.quantity || 0);
    const delta = newQty - oldQty;
    if (delta > 0) {
      const prod = products.find((p) => p.id === productId);
      const available = Number(prod?.stock || 0);
      if (delta > available) {
        toast.error(
          `⛔ المخزون غير كافٍ. المتوفر: ${available}، تحاول إضافة: ${delta}. لا يمكن إنزال المخزون للسالب.`
        );
        return;
      }
    }
    try {
      const { data } = await axios.patch(
        `${API}/admin/orders/${orderId}/items/${productId}`,
        { quantity: newQty }
      );
      toast.success(`تم تحديث الكمية — الفرق: ${Number(data.delta || 0).toLocaleString("en-US")} د.ع`);
      setEditingOrderItemQty(null);
      setEditItemQty("");
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "فشل تحديث الكمية");
    }
  };

  const handleResetOrders = async () => {
    const first = await confirmDialog(
      "⚠️ تحذير شديد!\n\nسيتم حذف:\n• جميع الطلبات والسحوبات ودفعات الديون\n• جميع الزبائن\n• جميع السائقين\n• جميع المشرفين\n• جميع المجاهزين\n\nالمنتجات والأقسام والشركات والإعدادات وحساب الأدمن — تبقى كما هي.\n\n💾 سيتم حفظ نسخة آمنة تلقائياً قبل الحذف (يمكن استعادتها من تبويب \"النسخ الآمنة\").\n\nهذا الإجراء لا يمكن التراجع عنه يدوياً. هل أنت متأكد؟"
    );
    if (!first) return;
    const confirmText = window.prompt('للتأكيد، اكتب: "تصفير"');
    if (confirmText !== "تصفير") {
      toast.error("تم إلغاء العملية");
      return;
    }
    try {
      const { data } = await axios.post(`${API}/admin/reset-orders`);
      toast.success(
        `✅ تم التصفير + حفظ نسخة آمنة | الطلبات: ${data.deleted_orders} • الزبائن: ${data.deleted_customers} • السائقين: ${data.deleted_drivers} • المشرفين: ${data.deleted_reps} • المجاهزين: ${data.deleted_mujahez}`,
        { duration: 10000 }
      );
      fetchData();
    } catch {
      toast.error("فشل تنفيذ التصفير");
    }
  };

  const handleLogout = async () => {
    // قبل الخروج: تنزيل النسخة الاحتياطية الكاملة تلقائياً
    const todayKey = `jumlaty_backup_${new Date().toISOString().slice(0,10)}`;
    const alreadyDone = localStorage.getItem(todayKey);
    if (!alreadyDone) {
      try {
        toast.info("جاري تنزيل النسخة الاحتياطية الكاملة قبل الخروج...");
        const totalDocs = await downloadDailyBackup();
        localStorage.setItem(todayKey, "1");
        toast.success(`تم حفظ النسخة الاحتياطية (${totalDocs} وثيقة)`);
      } catch {
        toast.error("تعذّر تنزيل النسخة — يرجى التحقق من الاتصال");
      }
    }
    logout();
    navigate("/login");
  };

  const handleBackupNow = async () => {
    try {
      toast.info("جاري تجهيز النسخة الاحتياطية الكاملة...");
      const totalDocs = await downloadDailyBackup();
      toast.success(`تم تنزيل النسخة الاحتياطية (${totalDocs} وثيقة)`);
    } catch {
      toast.error("فشل تنزيل النسخة الاحتياطية");
    }
  };

  const handleRestoreBackup = () => {
    const inp = document.createElement("input");
    inp.type = "file";
    inp.accept = "application/json,.json";
    inp.onchange = async (e) => {
      const file = e.target.files?.[0];
      if (!file) return;
      const mode = await confirmDialog(
        `سيتم استعادة البيانات من الملف: ${file.name}\n\n` +
        `اضغط "موافق" لـ استعادة "دمج" (آمنة — تضيف/تحدّث فقط)\n` +
        `اضغط "إلغاء" ثم أعد المحاولة لـ "استبدال كامل" (يحذف كل البيانات الحالية أولاً)`
      ) ? "merge" : null;
      if (!mode) {
        const replace = await confirmDialog(
          `⚠️ هل تريد استبدال كامل البيانات؟\n` +
          `سيتم حذف جميع البيانات الحالية (عدا حسابك الإداري) واستبدالها بالبيانات من الملف.\n` +
          `هذه العملية لا يمكن التراجع عنها.`
        );
        if (!replace) { toast.info("تم إلغاء الاستعادة"); return; }
      }
      try {
        toast.info("جاري استعادة البيانات...");
        const result = await restoreFullBackup(file, mode || "replace");
        const restored = result.restored || {};
        const totalRestored = Object.values(restored).reduce((s, v) => s + (v.total || 0), 0);
        toast.success(`تمت الاستعادة (${totalRestored} وثيقة من ${Object.keys(restored).length} مجموعة)`);
        // refresh data after restore
        setTimeout(() => window.location.reload(), 1500);
      } catch (err) {
        toast.error(err.message || "فشل الاستعادة");
      }
    };
    inp.click();
  };

  // Compute badge counts for tile grid
  // Pending driver orders count — drives the badge on the "إغلاق طلبات السواق" tile.
  // Computed from the in-memory orders list (orders with a driver assigned
  // but not yet delivered/rejected/pending) so it stays in sync with the
  // existing poll without extra API calls.
  const pendingDriverOrdersCount = orders.filter(
    (o) =>
      o.driver_id &&
      o.status !== "delivered" &&
      o.status !== "rejected" &&
      o.status !== "pending",
  ).length;

  const badges = {
    withdrawals: pendingWithdrawals,
    debts: pendingDebtPayments,
    payments: pendingPaymentConfirms,
    cash_subs: pendingCashSubmissions,
    returns: pendingReturns,
    purchase_proposals: pendingPurchaseProposals,
    slow_moving: slowMovingCount,
    pending_customers: pendingCustomersCount,
    account_balances: 0,
    pending_driver_orders: pendingDriverOrdersCount,
  };

  // Stable sequential ordering: sort by created_at ASC and assign 1,2,3...
  // Each tab gets its own status scope:
  //   - "orders"           → ONLY new orders awaiting approval (pending) + rejected.
  //   - "orders-confirmed" → everything that was approved & charged to the
  //     customer: confirmed/mujahez_*/ready/assigned/accepted/on_the_way/
  //     delivering/awaiting_payment_confirmation/delivered. Direct-sale
  //     invoices auto-charge the customer at creation, so they appear here too.
  const PENDING_SCOPE = ["pending", "rejected"];
  const CONFIRMED_SCOPE = [
    "confirmed", "mujahez_assigned", "mujahez_preparing", "ready_for_driver",
    "assigned", "accepted", "on_the_way", "delivering",
    "awaiting_payment_confirmation", "delivered",
  ];
  const filteredOrders = (() => {
    const tabScope = activeTab === "orders-confirmed" ? CONFIRMED_SCOPE : PENDING_SCOPE;
    // Merge server-side search hits (which may include invoices older
    // than the loaded 500-doc window) with the recent orders in state.
    // Dedup by id so the same order doesn't appear twice.
    const q = (orderSearch || "").trim();
    let sourceList = orders;
    if (q && orderSearchHits.length) {
      const byId = new Map();
      for (const o of orders) byId.set(o.id, o);
      for (const o of orderSearchHits) if (!byId.has(o.id)) byId.set(o.id, o);
      sourceList = Array.from(byId.values());
    }
    // POLICY (Feb 27, 2026): Supervisor invoices flagged
    // `awaiting_admin_confirmation=true` live in the «Pending» bucket
    // visually, even though their actual status is "confirmed" (so
    // stock/debt/profit count immediately). They only graduate to the
    // «Confirmed Invoices» bucket after an admin acknowledges them.
    let arr = sourceList.filter((o) => {
      const inScope = tabScope.includes(o.status);
      const awaitingSup = !!o.awaiting_admin_confirmation && !!o.is_supervisor_sale;
      if (activeTab === "orders-confirmed") {
        return inScope && !awaitingSup;
      }
      // Pending tab: status in PENDING_SCOPE OR a supervisor sale still awaiting confirmation
      return inScope || awaitingSup;
    });
    if (filter !== "all") {
      // On the Pending tab, "pending" filter should ALSO include supervisor
      // invoices still awaiting admin confirmation (their actual status is
      // "confirmed" but presentation-wise they live in this bucket).
      if (activeTab !== "orders-confirmed" && filter === "pending") {
        arr = arr.filter((o) => o.status === "pending" || (o.awaiting_admin_confirmation && o.is_supervisor_sale));
      } else {
        arr = arr.filter((o) => o.status === filter);
      }
    }
    // Day-offset filter — only on orders/orders-confirmed tabs, when in
    // compact view AND no active search. When user is actively searching,
    // we bypass the day filter so old invoices can surface too.
    //
    // IMPORTANT (Feb 2026 fix): On the CONFIRMED tab we filter by
    // `confirmed_at` (when the ADMIN pressed تأكيد), NOT by `created_at`
    // (when the customer placed the order). Otherwise an order that a
    // customer placed yesterday and the admin confirmed this morning
    // disappears from today's confirmed view — which was the exact bug
    // the user hit ("فواتير مؤكدة اليوم مفقودة"). The Pending tab still
    // filters by `created_at` since orders there are inherently new.
    if (
      (activeTab === "orders" || activeTab === "orders-confirmed") &&
      ordersView === "compact" &&
      typeof dayOffset === "number" &&
      !q
    ) {
      // Compute window [start, end] in UTC ISO based on dayOffset days back
      // from the current Baghdad day start.
      const now = new Date();
      // Baghdad UTC+3 — convert: now's Baghdad day starts at 00:00 Baghdad
      // which is 21:00 UTC of the previous day. We'll use a simple
      // approximation: today's Baghdad start = today 00:00 in user-local then
      // shift. For accuracy, just use last 24h windows ending at NOW.
      const periodEnd = new Date(now.getTime() - dayOffset * 86400000);
      const periodStart = new Date(periodEnd.getTime() - 86400000);
      arr = arr.filter((o) => {
        const ts =
          activeTab === "orders-confirmed"
            ? (o.confirmed_at || o.admin_confirmed_at || o.created_at || "")
            : (o.created_at || "");
        return ts >= periodStart.toISOString() && ts <= periodEnd.toISOString();
      });
    }
    // search text — when search is active, INCLUDE admin-hidden invoices
    // so the admin can still find them by name/phone/invoice#. Otherwise
    // hide them from the visible board. (`q` is already defined at the
    // top of this IIFE from the search-merge step.)
    const qLower = q.toLowerCase();
    if (qLower) {
      arr = arr.filter((o) => {
        const cust = String(o.customer_id || "").toLowerCase();
        const name = (o.user_name || "").toLowerCase();
        const market = (o.market_name || "").toLowerCase();
        const phone = (o.user_phone || "").toLowerCase();
        const inv = String(o.invoice_number || "").toLowerCase();
        return cust.includes(qLower) || name.includes(qLower) || market.includes(qLower) || phone.includes(qLower) || inv.includes(qLower);
      });
    } else {
      arr = arr.filter((o) => !o.admin_hidden);
    }
    // date filter — use `confirmed_at` on the CONFIRMED tab, `created_at`
    // elsewhere (so "today" in Confirmed = orders confirmed today, and
    // "today" in Pending = orders placed today).
    const _dateKey = (o) => {
      if (activeTab === "orders-confirmed") {
        return (o.confirmed_at || o.admin_confirmed_at || o.created_at || "").slice(0, 10);
      }
      return (o.created_at || "").slice(0, 10);
    };
    if (orderDateFilter === "today") {
      const today = new Date().toISOString().slice(0, 10);
      arr = arr.filter((o) => _dateKey(o) === today);
    } else if (orderDateFilter === "range") {
      const from = orderDateFrom;
      const to = orderDateTo;
      arr = arr.filter((o) => {
        const d = _dateKey(o);
        if (from && d < from) return false;
        if (to && d > to) return false;
        return true;
      });
    }
    // sort newest first for display, but compute sequence ASC then attach
    const sortedAsc = [...arr].sort((a, b) => String(a.created_at || "").localeCompare(String(b.created_at || "")));
    const seqMap = new Map(sortedAsc.map((o, i) => [o.id, i + 1]));
    return [...arr]
      .sort((a, b) => String(b.created_at || "").localeCompare(String(a.created_at || "")))
      .map((o) => ({ ...o, __seq: seqMap.get(o.id) || 0 }));
  })();

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <p className="text-[#5C6E64]">جاري التحميل...</p>
      </div>
    );
  }

  // ============= EMPLOYEES-ONLY ADMIN (07858877756) =============
  // This account is the HR/Operator hub. Originally locked to the Employees
  // Archive — expanded to a 4-tab portal: Employees, Purchase Companies,
  // Notes, and Price List. Pending Drafts bar applies here too.
  // `peekAdmin` lets the manager temporarily view the full admin dashboard
  // (toggle button in the header). When peekAdmin is true we fall through to
  // the normal admin layout below + a floating "back to manager" button.
  if (user?.is_employees_only && !peekAdmin) {
    // POLICY (Feb 28, 2026): Mohammed-Hussein manager portal (07858877756)
    // has Financial Summary / Receipts / Purchase Invoices REMOVED per
    // owner request — those tabs were too sensitive for the HR scope.
    const hrTabs = [
      { id: "employees", label: "أرشيف الموظفين", icon: Users, color: "#3B82F6" },
      { id: "purchase-companies", label: "شركات الشراء", icon: Building2, color: "#7ED321" },
      { id: "hr-notes", label: "الملاحظات", icon: StickyNote, color: "#F59E0B" },
      { id: "price-list", label: "قائمة الأسعار", icon: ListChecks, color: "#1E3A5F" },
      { id: "purchase-list", label: "قائمة الشراء", icon: ShoppingCart, color: "#7C3AED" },
      { id: "product-photos", label: "صور المواد", icon: Images, color: "#8B5CF6" },
      { id: "inventory-count", label: "جرد المخزن", icon: ClipboardList, color: "#0EA5E9" },
      { id: "driver-invoices", label: "فواتير السواق", icon: Truck, color: "#E85D45" },
      { id: "company-profits", label: "أرباح الشركة", icon: TrendingUp, color: "#1E3A5F" },
      { id: "company-expenses", label: "مصاريف الشركة", icon: Wallet, color: "#E85D45" },
    ];
    // Orders are intentionally HIDDEN from the manager — all order management
    // stays with the main admin. Receipt vouchers and purchase invoices are
    // first-class manager tools and share the same DB collections as admin
    // so any change here syncs automatically with the admin dashboard.
    const handleHrTabClick = (id) => {
      setActiveTab(id);
    };
    const hrActive = hrTabs.find((t) => t.id === activeTab) ? activeTab : "employees";
    return (
      <div className="min-h-screen bg-transparent" data-testid="employees-only-admin">
        <header className="sticky top-0 z-50 bg-[#1E3A5F] text-white">
          <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center gap-3">
            <div className="flex items-center gap-2 min-w-0">
              <BadgeDollarSign className="w-6 h-6 shrink-0" />
              <div className="min-w-0">
                <h1 className="font-heading font-bold text-xl truncate">حساب المدير</h1>
                <p className="text-[10px] opacity-80 truncate">جملتي · موظفين · شركات شراء · ملاحظات · أسعار</p>
              </div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              {/* User badge — shows the operator name (محمد حسين) for the HR account */}
              <div data-testid="hr-user-badge" className="hidden sm:flex items-center gap-1.5 bg-white/10 rounded-full pl-3 pr-2 py-1.5 text-xs font-bold">
                <span className="bg-white/25 rounded-full w-7 h-7 flex items-center justify-center text-[11px]">م ح</span>
                <span>محمد حسين</span>
              </div>
              {/* Quick jump to the customer-facing shop (read-only view) so the
                  manager can see exactly what shoppers see without logging out. */}
              <button
                type="button"
                onClick={() => navigate("/")}
                data-testid="hr-go-customer"
                title="فتح لوحة الزبائن (تسوّق)"
                aria-label="لوحة الزبائن"
                className="bg-[#7ED321] hover:bg-[#6cb91d] text-white text-xs font-bold px-3 py-2 rounded-full flex items-center gap-1.5 transition-colors shadow"
              >
                <ShoppingBag className="w-4 h-4" />
                <span className="hidden sm:inline">لوحة الزبائن</span>
              </button>
              {/* Peek the full admin dashboard (same as the head admin sees) */}
              <button
                type="button"
                onClick={() => togglePeekAdmin(true)}
                data-testid="hr-go-admin"
                title="فتح لوحة الإدارة الكاملة"
                aria-label="لوحة الإدارة"
                className="bg-[#F5A623] hover:bg-[#e09418] text-white text-xs font-bold px-3 py-2 rounded-full flex items-center gap-1.5 transition-colors shadow"
              >
                <ShieldCheck className="w-4 h-4" />
                <span className="hidden sm:inline">لوحة الإدارة</span>
              </button>
              {/* Bell with drafts dropdown — drafts auto-saved on form close.
                  Clicking a chip jumps back to the relevant tab and reopens the form. */}
              <BellDraftsButton
                onJump={(draftId) => {
                  const parentTab = draftId === "pc-form" ? "purchase-companies"
                    : draftId === "hr-notes-form" ? "hr-notes"
                    : draftId.startsWith("emp-") ? "employees"
                    : "employees";
                  setActiveTab(parentTab);
                  // Defer so the tab renders before we ask it to open the modal
                  setTimeout(() => {
                    window.dispatchEvent(new CustomEvent("hr-resume-draft", { detail: { draftId, tab: parentTab } }));
                  }, 80);
                }}
              />
              <button
                onClick={handleLogout}
                data-testid="admin-logout"
                className="flex items-center gap-2 bg-[#E85D45] hover:bg-[#d54d35] px-4 py-2 rounded-full text-sm font-medium transition-colors"
              >
                <LogOut className="w-4 h-4" />
                تسجيل الخروج
              </button>
            </div>
          </div>
        </header>

        <main className="max-w-6xl mx-auto px-4 py-5" dir="rtl">
          {/* Tab Switcher — wraps to multiple rows on wider screens (laptop/desktop)
              so all 7 tabs are always visible. Mobile/tablet still scrolls
              horizontally to save vertical space. */}
          <div
            data-testid="hr-tab-switcher"
            className="flex gap-2 overflow-x-auto md:overflow-x-visible md:flex-wrap pb-3 mb-4 -mx-1 px-1 sticky top-[80px] z-30 bg-[#FAFCFA] py-2 border-b border-[#E4EBE6]"
          >
            {hrTabs.map((t) => {
              const Icon = t.icon;
              const on = hrActive === t.id;
              return (
                <button
                  key={t.id}
                  type="button"
                  onClick={() => handleHrTabClick(t.id)}
                  data-testid={`hr-tab-${t.id}`}
                  className={`shrink-0 inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-bold border-2 transition-colors ${
                    on
                      ? "text-white border-transparent shadow"
                      : "bg-white text-[#1E3A5F] border-[#E4EBE6] hover:border-[#3B82F6]"
                  }`}
                  style={on ? { backgroundColor: t.color } : undefined}
                >
                  <Icon className="w-4 h-4" />
                  {t.label}
                </button>
              );
            })}
          </div>

          <div className="bg-white rounded-2xl border border-[#E4EBE6] shadow-sm p-3 sm:p-4">
            {hrActive === "summary" && <HRSummaryStrips />}
            {hrActive === "purchase-companies" && <PurchaseCompaniesTab />}
            {hrActive === "hr-notes" && <HRNotesTab />}
            {hrActive === "price-list" && <PriceListTab />}
            {hrActive === "driver-invoices" && <DriverInvoicesBoard />}
            {hrActive === "company-profits" && <ManagerLedger resource="profits" />}
            {hrActive === "company-expenses" && <ManagerLedger resource="expenses" />}
            {hrActive === "purchase-list" && <PurchaseListTab />}
            {hrActive === "product-photos" && <ProductPhotosTab />}
            {hrActive === "inventory-count" && <InventoryCountTab />}
            {hrActive === "employees" && <EmployeesTab />}
          </div>
        </main>
      </div>
    );
  }

  return (
    <div
      className="min-h-screen bg-transparent relative"
      style={user?.background_photo ? {
        backgroundImage: `url(${API}/files/${user.background_photo})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      } : {}}
    >
      {/* Floating "Dismiss alarm" button — covers the whole screen with a
          big red modal-style banner while the air-raid siren is wailing.
          One tap silences and hides. Designed to be impossible to miss. */}
      {alarmActive && (
        <div className="fixed inset-x-0 top-0 z-[200] flex items-start justify-center pointer-events-none">
          <div
            className="pointer-events-auto mt-2 bg-gradient-to-l from-[#E85D45] to-[#cf4933] text-white rounded-3xl shadow-2xl px-4 py-3 flex items-center gap-3 animate-pulse"
            style={{ minWidth: 320, boxShadow: "0 10px 40px rgba(232,93,69,0.6)" }}
            data-testid="alarm-banner"
          >
            <div className="w-10 h-10 rounded-full bg-white/25 backdrop-blur flex items-center justify-center shrink-0">
              <BellOff className="w-5 h-5" />
            </div>
            <div className="flex-1 text-right">
              <p className="font-black text-base leading-tight">إجاكم طلب جديد!</p>
              <p className="text-[10px] opacity-90">اضغط إبعاد لإيقاف الصوت</p>
            </div>
            <button
              type="button"
              onClick={() => { stopAlarm(); setAlarmActive(false); }}
              data-testid="alarm-stop-btn"
              className="bg-white text-[#E85D45] font-black px-4 py-2 rounded-2xl shadow active:scale-95 transition-transform shrink-0"
            >
              إبعاد
            </button>
          </div>
        </div>
      )}
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#2D4A3E] text-white">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <div>
            <h1 className="font-heading font-bold text-2xl">لوحة الإدارة</h1>
            <p className="text-xs opacity-80">جملتي - إدارة الطلبات</p>
          </div>
          <div className="flex items-center gap-3">
            <PushPermissionButton />
            <AdminNotes />
            <BellDraftsButton onJump={() => {}} />
            {(isMaster || isSubAdmin) && (
              <button
                onClick={() => setShowMasterProfile(true)}
                data-testid="master-profile-open"
                title="الملف الشخصي"
                className="relative p-1 hover:bg-white/10 rounded-full transition-colors ring-2 ring-white/20 hover:ring-white/50"
              >
                {user?.profile_photo ? (
                  <img
                    src={`${API}/files/${user.profile_photo}`}
                    alt="me"
                    className="w-8 h-8 rounded-full object-cover"
                  />
                ) : (
                  <div className="w-8 h-8 rounded-full bg-white text-[#1E3A5F] flex items-center justify-center font-black text-sm">
                    {(user?.full_name || "?")[0]}
                  </div>
                )}
              </button>
            )}
            <button
              onClick={() => setShowLowStock(true)}
              data-testid="low-stock-bell"
              title={lowStockCount > 0 ? `${lowStockCount} منتج بحاجة لإعادة شراء` : "تنبيهات المخزن"}
              className="relative p-2 hover:bg-white/10 rounded-full transition-colors"
            >
              <Bell className={`w-5 h-5 ${lowStockCount > 0 ? "text-[#F5A623] animate-pulse" : ""}`} />
              {lowStockCount > 0 && (
                <span
                  data-testid="low-stock-badge"
                  className="absolute -top-1 -right-1 bg-[#E85D45] text-white text-[10px] font-black rounded-full w-5 h-5 flex items-center justify-center"
                  dir="ltr"
                >
                  {lowStockCount > 99 ? "99+" : lowStockCount}
                </span>
              )}
            </button>
            <button
              onClick={fetchData}
              data-testid="refresh-btn"
              className="p-2 hover:bg-white/10 rounded-full transition-colors"
            >
              <RefreshCw className="w-5 h-5" />
            </button>
            <button
              onClick={handleBackupNow}
              data-testid="backup-now-btn"
              title="تنزيل نسخة احتياطية كاملة للبرنامج"
              className="flex items-center gap-2 bg-[#1E3A5F] hover:bg-[#152a45] px-3 py-2 rounded-full text-sm font-medium transition-colors"
            >
              <Archive className="w-4 h-4" />
              نسخة كاملة
            </button>
            <button
              onClick={handleRestoreBackup}
              data-testid="restore-backup-btn"
              title="استعادة البيانات من ملف نسخة احتياطية"
              className="flex items-center gap-2 bg-[#7ED321] hover:bg-[#6cb91d] px-3 py-2 rounded-full text-sm font-medium transition-colors"
            >
              <Upload className="w-4 h-4" />
              استعادة
            </button>
            <button
              onClick={handleLogout}
              data-testid="admin-logout"
              className="flex items-center gap-2 bg-[#E85D45] hover:bg-[#d54d35] px-4 py-2 rounded-full text-sm font-medium transition-colors"
            >
              <LogOut className="w-4 h-4" />
              تسجيل الخروج
            </button>
          </div>
        </div>
      </header>

      <PendingDraftsBar activeTab={activeTab} switchTab={setActiveTab} />

      {/* Global cascade-reveal keyframes.
          .icon-cascade / .kpi-cascade — one-shot after welcome splash closes
          .tile-cascade — runs every time the tile menu re-opens (owner asked
          Feb 27, 2026 to reuse the eDEX-UI-style intro when re-visiting home). */}
      <style>{`
        @keyframes jumlatyTileReveal {
          0%   { opacity: 0; transform: scale(0.5) translateY(30px) rotate(-6deg); filter: blur(4px); }
          70%  { opacity: 1; transform: scale(1.05) translateY(-4px) rotate(2deg); filter: blur(0); }
          100% { opacity: 1; transform: scale(1) translateY(0) rotate(0deg); filter: blur(0); }
        }
        .tile-cascade > * {
          animation: jumlatyTileReveal 0.65s cubic-bezier(0.34, 1.56, 0.64, 1) both;
        }
        .tile-cascade > *:nth-child(1)  { animation-delay: 20ms; }
        .tile-cascade > *:nth-child(2)  { animation-delay: 60ms; }
        .tile-cascade > *:nth-child(3)  { animation-delay: 100ms; }
        .tile-cascade > *:nth-child(4)  { animation-delay: 140ms; }
        .tile-cascade > *:nth-child(5)  { animation-delay: 180ms; }
        .tile-cascade > *:nth-child(6)  { animation-delay: 220ms; }
        .tile-cascade > *:nth-child(7)  { animation-delay: 260ms; }
        .tile-cascade > *:nth-child(8)  { animation-delay: 300ms; }
        .tile-cascade > *:nth-child(9)  { animation-delay: 340ms; }
        .tile-cascade > *:nth-child(10) { animation-delay: 380ms; }
        .tile-cascade > *:nth-child(11) { animation-delay: 420ms; }
        .tile-cascade > *:nth-child(12) { animation-delay: 460ms; }
        .tile-cascade > *:nth-child(n+13) { animation-delay: 500ms; }
      `}</style>

      {/* Cascade-reveal animation for the header icons after the welcome
          splash closes (eDEX-UI-style intro requested Feb 27, 2026). */}
      {iconsRevealed && (
        <style>{`
          @keyframes jumlatyIconReveal {
            0%   { opacity: 0; transform: scale(0.3) rotate(-90deg); }
            60%  { opacity: 1; transform: scale(1.15) rotate(8deg); }
            100% { opacity: 1; transform: scale(1) rotate(0deg); }
          }
          .icon-cascade > button, .icon-cascade > a {
            animation: jumlatyIconReveal 0.75s cubic-bezier(0.34, 1.56, 0.64, 1) both;
          }
          .icon-cascade > button:nth-child(1) { animation-delay: 0ms; }
          .icon-cascade > button:nth-child(2) { animation-delay: 90ms; }
          .icon-cascade > button:nth-child(3) { animation-delay: 180ms; }
          .icon-cascade > button:nth-child(4) { animation-delay: 270ms; }
          .icon-cascade > button:nth-child(5) { animation-delay: 360ms; }
          .icon-cascade > button:nth-child(6) { animation-delay: 450ms; }
          .icon-cascade > button:nth-child(7) { animation-delay: 540ms; }
          .icon-cascade > button:nth-child(8) { animation-delay: 630ms; }
          .icon-cascade > button:nth-child(9) { animation-delay: 720ms; }
          .icon-cascade > button:nth-child(10) { animation-delay: 810ms; }
          .icon-cascade > button:nth-child(11) { animation-delay: 900ms; }
          .icon-cascade > button:nth-child(12) { animation-delay: 990ms; }
          @keyframes jumlatyKpiReveal {
            0% { opacity: 0; transform: translateY(30px) scale(0.85); }
            100% { opacity: 1; transform: translateY(0) scale(1); }
          }
          .kpi-cascade > * {
            animation: jumlatyKpiReveal 0.55s cubic-bezier(0.34, 1.56, 0.64, 1) both;
          }
          .kpi-cascade > *:nth-child(1) { animation-delay: 100ms; }
          .kpi-cascade > *:nth-child(2) { animation-delay: 180ms; }
          .kpi-cascade > *:nth-child(3) { animation-delay: 260ms; }
          .kpi-cascade > *:nth-child(4) { animation-delay: 340ms; }
          .kpi-cascade > *:nth-child(5) { animation-delay: 420ms; }
          .kpi-cascade > *:nth-child(6) { animation-delay: 500ms; }
        `}</style>
      )}

      <main className="max-w-7xl mx-auto px-4 py-6 space-y-6" dir="rtl">
        {/* Sticky Page Header — Home button + global invoice search + current section */}
        <div className="sticky top-[80px] z-40 bg-[#FAFCFA] -mx-4 px-4 py-3 border-b border-[#E4EBE6] flex items-center gap-3 flex-wrap icon-cascade">
          <button
            onClick={() => {
              if (activeTab !== "home") {
                setActiveTab("home");
                setShowTileMenu(true);
              } else {
                setShowTileMenu((s) => !s);
              }
            }}
            data-testid="admin-home-btn"
            className={`p-3 rounded-2xl shadow-md transition-all ${
              showTileMenu
                ? "bg-[#E85D45] text-white scale-110"
                : "bg-white border-2 border-[#E85D45] text-[#E85D45] hover:bg-[#E85D45] hover:text-white"
            }`}
            title="الأقسام"
          >
            <Home className="w-5 h-5" />
          </button>
          {/* Switch to customer view (admin-only, icon-only) */}
          {canSeePortal("portal-customer") && (
          <button
            onClick={() => navigate("/")}
            data-testid="admin-view-as-customer"
            title="عرض كزبون"
            className="p-3 rounded-2xl shadow-md bg-[#2D4A3E] hover:bg-[#1f3529] text-white transition-colors"
          >
            <UserCog className="w-5 h-5" />
          </button>
          )}
          {/* View as Driver */}
          {canSeePortal("portal-driver") && (
          <button
            onClick={() => navigate("/driver")}
            data-testid="admin-view-as-driver"
            title="عرض كسائق"
            className="p-3 rounded-2xl shadow-md bg-[#E85D45] hover:bg-[#c14a36] text-white transition-colors"
          >
            <Truck className="w-5 h-5" />
          </button>
          )}
          {/* View as Mujahez */}
          {canSeePortal("portal-mujahez") && (
          <button
            onClick={() => navigate("/mujahez-jumlaty")}
            data-testid="admin-view-as-mujahez"
            title="عرض كمجهّز"
            className="p-3 rounded-2xl shadow-md bg-[#F5A623] hover:bg-[#dc9320] text-white transition-colors"
          >
            <Package className="w-5 h-5" />
          </button>
          )}
          {/* View as Rep */}
          {canSeePortal("portal-rep") && (
          <button
            onClick={() => navigate("/mushrif-jumlaty")}
            data-testid="admin-view-as-rep"
            title="عرض كمشرف"
            className="p-3 rounded-2xl shadow-md bg-[#3B82F6] hover:bg-[#2563EB] text-white transition-colors"
          >
            <UserCog className="w-5 h-5" />
          </button>
          )}
          {/* Complaints bell — opens admin complaints tab */}
          {canSeePortal("portal-complaints") && (
          <button
            onClick={() => setActiveTab("complaints")}
            data-testid="admin-complaints-btn"
            title="الشكاوي والملاحظات من الزبائن"
            className="p-3 rounded-2xl shadow-md bg-[#dc2626] hover:bg-[#b91c1c] text-white transition-colors relative"
          >
            <AlertCircle className={`w-5 h-5 ${complaintsUnreadCount > 0 ? "animate-pulse" : ""}`} />
            {complaintsUnreadCount > 0 && (
              <span
                data-testid="complaints-badge"
                className="absolute -top-1 -right-1 bg-[#FBBF24] text-[#7c2d12] text-[10px] font-black rounded-full w-5 h-5 flex items-center justify-center"
                dir="ltr"
              >
                {complaintsUnreadCount > 99 ? "99+" : complaintsUnreadCount}
              </span>
            )}
          </button>
          )}
          {/* Money-Box (تأكيد الأموال) — purple wallet icon */}
          <button
            onClick={() => setActiveTab("money-box")}
            data-testid="admin-money-box-btn"
            title="تأكيد الأموال — أموال السائقين بانتظار تأكيد الأدمن"
            className="p-3 rounded-2xl shadow-md bg-[#7C3AED] hover:bg-[#6d28d9] text-white transition-colors relative"
          >
            <Wallet className={`w-5 h-5 ${moneyBoxPendingCount > 0 ? "animate-pulse" : ""}`} />
            {moneyBoxPendingCount > 0 && (
              <span
                data-testid="money-box-badge"
                className="absolute -top-1 -right-1 bg-[#FBBF24] text-[#5b21b6] text-[10px] font-black rounded-full w-5 h-5 flex items-center justify-center"
                dir="ltr"
              >
                {moneyBoxPendingCount > 99 ? "99+" : moneyBoxPendingCount}
              </span>
            )}
            <span className="absolute -bottom-5 left-1/2 -translate-x-1/2 whitespace-nowrap text-[9px] font-bold text-[#7C3AED] bg-white shadow rounded-full px-1.5 py-0.5">تأكيد الأموال</span>
          </button>
          {/* Supervisor price-approvals — orange shield icon */}
          <button
            onClick={() => setActiveTab("sup-price-approvals")}
            data-testid="admin-sup-price-btn"
            title="تأكيد تغيير الأسعار من المشرفين"
            className="p-3 rounded-2xl shadow-md bg-[#F5A623] hover:bg-[#d97706] text-white transition-colors relative"
          >
            <ShieldCheck className={`w-5 h-5 ${supPriceApprovalsPending > 0 ? "animate-pulse" : ""}`} />
            {supPriceApprovalsPending > 0 && (
              <span
                data-testid="sup-price-badge"
                className="absolute -top-1 -right-1 bg-[#dc2626] text-white text-[10px] font-black rounded-full w-5 h-5 flex items-center justify-center"
                dir="ltr"
              >
                {supPriceApprovalsPending > 99 ? "99+" : supPriceApprovalsPending}
              </span>
            )}
            <span className="absolute -bottom-5 left-1/2 -translate-x-1/2 whitespace-nowrap text-[9px] font-bold text-[#F5A623] bg-white shadow rounded-full px-1.5 py-0.5">تأكيد السعر</span>
          </button>
          {/* Global Invoice Search */}
          <div className="relative flex-1 min-w-[220px] max-w-xl">
            <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#5C6E64]" />
            <input
              type="text"
              value={globalInvoiceSearch}
              onChange={(e) => setGlobalInvoiceSearch(e.target.value)}
              onFocus={() => { if (globalInvoiceSearch.trim()) setShowInvoiceResults(true); }}
              placeholder="🧾 بحث برقم الفاتورة / الايباد / اسم الزبون / الماركت..."
              data-testid="global-invoice-search"
              className="w-full pr-9 pl-9 py-2.5 rounded-full bg-white border-2 border-[#3B82F6]/30 text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6] focus:border-[#3B82F6]"
            />
            {globalInvoiceSearch && (
              <button
                onClick={() => { setGlobalInvoiceSearch(""); setShowInvoiceResults(false); }}
                data-testid="global-invoice-clear"
                className="absolute left-3 top-1/2 -translate-y-1/2 p-1 hover:bg-[#F3F6F4] rounded-full"
              >
                <X className="w-3.5 h-3.5 text-[#5C6E64]" />
              </button>
            )}
            {/* Results dropdown */}
            {globalInvoiceSearch.trim() && showInvoiceResults && (
              <div
                data-testid="global-invoice-results"
                className="absolute top-full left-0 right-0 mt-2 bg-white border-2 border-[#3B82F6]/30 rounded-2xl shadow-2xl max-h-[60vh] overflow-y-auto z-50"
              >
                {(() => {
                  const q = globalInvoiceSearch.trim().toLowerCase();
                  const matches = orders.filter((o) => {
                    const fields = [
                      String(o.invoice_number || ""),
                      String(o.id || "").slice(0, 8),
                      o.user_name || "", o.market_name || "",
                      o.user_phone || "", String(o.customer_id || ""),
                    ].map((x) => x.toLowerCase());
                    return fields.some((f) => f.includes(q));
                  }).slice(0, 8);
                  if (matches.length === 0) {
                    return <div className="p-4 text-center text-sm text-[#5C6E64]">لا نتائج لـ "{globalInvoiceSearch}"</div>;
                  }
                  return matches.map((o) => (
                    <div
                      key={o.id}
                      data-testid={`global-invoice-result-${o.id}`}
                      className="border-b border-[#E4EBE6] last:border-b-0 p-3 hover:bg-[#F0F9FF] cursor-pointer"
                      onClick={() => {
                        setActiveTab("orders");
                        setOrderSearch(String(o.invoice_number || o.id));
                        setShowInvoiceResults(false);
                        setShowTileMenu(false);
                        // Scroll into view after render
                        setTimeout(() => {
                          const el = document.querySelector(`[data-testid="admin-order-${o.id}"]`);
                          if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
                        }, 250);
                      }}
                    >
                      <div className="flex justify-between items-start gap-2 flex-wrap">
                        <div className="flex items-center gap-2">
                          <span className="bg-[#1E3A5F] text-white font-black px-2.5 py-1 rounded-lg text-sm" dir="ltr">
                            #{o.invoice_number || (o.id || "").slice(0, 6)}
                          </span>
                          <div>
                            <p className="font-bold text-[#111814] text-sm">{o.user_name || "—"}</p>
                            <p className="text-xs text-[#5C6E64]">{o.market_name || ""}</p>
                          </div>
                        </div>
                        <span
                          className="px-2 py-0.5 rounded-full text-[10px] font-bold"
                          style={{
                            backgroundColor: `${statusConfig[o.status]?.color || "#5C6E64"}20`,
                            color: statusConfig[o.status]?.color || "#5C6E64",
                          }}
                        >
                          {statusConfig[o.status]?.label || o.status}
                        </span>
                      </div>
                      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mt-2 text-[11px]">
                        <div className="bg-[#F5A623]/20 text-[#F5A623] rounded-lg px-2 py-1">
                          <p className="opacity-80">الايباد</p>
                          <p className="font-bold" dir="ltr">{o.customer_id || "—"}</p>
                        </div>
                        <div className="bg-[#E85D45]/20 text-[#E85D45] rounded-lg px-2 py-1">
                          <p className="opacity-80">المجموع</p>
                          <p className="font-bold" dir="ltr">{Number(o.total || 0).toLocaleString("en-US")} د.ع</p>
                        </div>
                        {o.amount_paid !== undefined && (
                          <div className="bg-[#7ED321]/20 text-[#7ED321] rounded-lg px-2 py-1">
                            <p className="opacity-80">المحصّل</p>
                            <p className="font-bold" dir="ltr">{Number(o.amount_paid || 0).toLocaleString("en-US")}</p>
                          </div>
                        )}
                        {o.amount_remaining > 0 && (
                          <div className="bg-[#3B82F6]/20 text-[#3B82F6] rounded-lg px-2 py-1">
                            <p className="opacity-80">المتبقّي</p>
                            <p className="font-bold" dir="ltr">{Number(o.amount_remaining || 0).toLocaleString("en-US")}</p>
                          </div>
                        )}
                      </div>
                      <p className="text-[10px] text-[#5C6E64] mt-1">
                        {(o.items || []).map((it) => `${it.name_ar}×${it.quantity}`).join("، ")}
                      </p>
                    </div>
                  ));
                })()}
              </div>
            )}
          </div>
          <div className="flex-1">
            <p className="text-xs text-[#5C6E64]">لوحة الإدارة</p>
            <h2 className="font-heading font-bold text-lg text-[#111814]">
              {TAB_LABELS[activeTab] || "الرئيسية"}
            </h2>
          </div>
          {activeTab !== "home" && (
            <ChevronLeft className="w-5 h-5 text-[#5C6E64]" />
          )}
        </div>

        {/* HOME VIEW — Today stats + Tile Grid */}
        {activeTab === "home" && stats && (
          <div className="space-y-5">
            {/* Historical stats search — pick any past Iraqi business day or
                date range to see how much was sold/profit/cartons that day.
                Numbers shown here NEVER replace today's cards; this is purely
                a query tool. The data is always in the DB. */}
            <HistoricalStatsBar />

            {/* 5 Today Stat Cards — now CUMULATIVE (never reset). Eye toggle
                masks the values when admin wants to hide them in front of
                staff/customers without deleting any data. */}
            <div className="flex items-center justify-end gap-2 -mb-2">
              <button
                type="button"
                onClick={toggleHideAmounts}
                data-testid="toggle-hide-amounts"
                title={hideAmounts ? "إظهار الأرقام" : "إخفاء الأرقام"}
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white border border-[#E4EBE6] text-[#1E3A5F] text-xs font-bold hover:bg-[#1E3A5F] hover:text-white transition-colors"
              >
                {hideAmounts ? <Eye className="w-3.5 h-3.5" /> : <EyeOff className="w-3.5 h-3.5" />}
                <span>{hideAmounts ? "إظهار الأرقام" : "إخفاء الأرقام"}</span>
              </button>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-3 kpi-cascade">
              {canSeeWidget("widget-total-sales") && (
                <TodayStat icon={DollarSign} label="إجمالي المبيعات" value={maskVal(`${fmtMoney(stats.cumulative_revenue ?? stats.today_sold, user)} د.ع`)} />
              )}
              {canSeeWidget("widget-total-received") && (
                <TodayStat icon={Wallet} label="إجمالي المُستلَم" value={maskVal(`${fmtMoney(stats.cumulative_revenue ?? stats.today_received, user)} د.ع`)} />
              )}
              {canSeeWidget("widget-total-cartons") && (
                <TodayStat icon={Package} label="إجمالي الكراتين" value={maskVal(`${stats.cumulative_cartons ?? stats.today_cartons ?? 0}`)} />
              )}
              {canSeeWidget("widget-orders-done") && (
                <TodayStat icon={CheckCircle} label="الطلبات المنجزة" value={`${stats.delivered || 0}`} />
              )}
              {canSeeWidget("widget-orders-pending") && (
                <TodayStat icon={Clock} label="طلبات قيد الإنجاز" value={`${stats.today_orders_pending || 0}`} />
              )}
            </div>

            {/* Profit + Capital + Expenses highlights */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 kpi-cascade">
              {canSeeWidget("widget-cumulative-profit") && (
              <button
                type="button"
                onClick={() => setShowMonthlyNetProfit(true)}
                data-testid="today-profit-card"
                className={`text-right bg-gradient-to-l ${(stats.cumulative_profit ?? stats.today_profit) < 0 ? "from-[#7F1D1D] to-[#B91C1C]" : "from-[#1E3A5F] to-[#3B82F6]"} hover:brightness-110 text-white rounded-2xl p-5 flex items-center justify-between transition-shadow shadow-md hover:shadow-lg`}
              >
                <div>
                  <p className="text-xs opacity-90">أرباح الفترة الحالية (تراكميّة)</p>
                  <p className="font-bold text-3xl mt-1" dir="ltr">{maskVal(`${fmtMoney(stats.cumulative_profit ?? stats.today_profit, user)} د.ع`)}</p>
                  <p className="text-[10px] opacity-80 mt-1">🔄 تشمل أمس + الشهر الحالي • اضغط لعرض دوائر الأشهر</p>
                </div>
                <TrendingUp className="w-12 h-12 opacity-80" />
              </button>
              )}
              {canSeeWidget("widget-capital") && (
              <button
                type="button"
                onClick={() => setActiveTab("capital")}
                data-testid="capital-kpi-card"
                className="text-right bg-gradient-to-l from-[#15803d] to-[#22c55e] hover:from-[#126b32] hover:to-[#1ea34e] text-white rounded-2xl p-5 flex items-center justify-between transition-shadow shadow-md hover:shadow-lg"
              >
                <div>
                  <p className="text-xs opacity-90 flex items-center gap-1">
                    <Coins className="w-3.5 h-3.5" /> رأس المال (متحرّك)
                  </p>
                  <p className="font-bold text-3xl mt-1" dir="ltr">
                    {capital ? fmtMoney(capital.capital, user) : "..."} د.ع
                  </p>
                  <p className="text-[10px] opacity-80 mt-1">اضغط لإدارة سندات رأس المال</p>
                </div>
                <Coins className="w-12 h-12 opacity-80" />
              </button>
              )}
              {canSeeWidget("widget-today-sales") && (
              <button
                type="button"
                onClick={() => setActiveTab("expenses")}
                data-testid="today-sales-kpi-card"
                className="text-right bg-gradient-to-l from-[#7C3AED] to-[#A855F7] hover:from-[#6d28d9] hover:to-[#9333ea] text-white rounded-2xl p-5 flex items-center justify-between transition-shadow shadow-md hover:shadow-lg"
              >
                <div>
                  <p className="text-xs opacity-90 flex items-center gap-1">
                    <DollarSign className="w-3.5 h-3.5" /> ايش بعنا اليوم
                  </p>
                  <p className="font-bold text-3xl mt-1" dir="ltr">
                    {fmtMoney(stats.today_sold, user)} د.ع
                  </p>
                  <p className="text-[10px] opacity-80 mt-1">إجمالي مبيعات هذا اليوم</p>
                </div>
                <DollarSign className="w-12 h-12 opacity-80" />
              </button>
              )}
              {/* Expenses card kept in code but HIDDEN per user request — restore by removing "hidden" class
              <button
                type="button"
                onClick={() => setActiveTab("expenses")}
                data-testid="expenses-kpi-card"
                className="hidden text-right bg-gradient-to-l from-[#E85D45] to-[#F97316] hover:from-[#d54d35] hover:to-[#ea6f0a] text-white rounded-2xl p-5 flex items-center justify-between transition-shadow shadow-md hover:shadow-lg"
              >
                <div>
                  <p className="text-xs opacity-90 flex items-center gap-1">
                    <TrendingDown className="w-3.5 h-3.5" /> المصاريف الكلية (اليوم)
                  </p>
                  <p className="font-bold text-3xl mt-1" dir="ltr">
                    {fmtMoney(stats.today_expenses, user)} د.ع
                  </p>
                  <p className="text-[10px] opacity-80 mt-1">سندات صرف + رواتب موظفين</p>
                </div>
                <TrendingDown className="w-12 h-12 opacity-80" />
              </button>
              */}
            </div>

            {/* Tile Grid removed — now appears as dropdown via Home button */}
          </div>
        )}

        {/* Tile Dropdown Menu (toggled by Home button) */}
        <AnimatePresence>
          {showTileMenu && (
            <motion.div
              initial={{ opacity: 0, y: -16, height: 0 }}
              animate={{ opacity: 1, y: 0, height: "auto" }}
              exit={{ opacity: 0, y: -8, height: 0 }}
              transition={{ duration: 0.25 }}
              data-testid="tile-dropdown"
              className="overflow-hidden"
            >
              <div className="bg-white border-2 border-[#3B82F6]/30 rounded-3xl shadow-2xl p-4 space-y-3 mt-2">
                <div className="bg-gradient-to-l from-[#1E3A5F] to-[#3B82F6] text-white rounded-2xl px-4 py-2 flex items-center justify-between">
                  <span className="font-bold">جميع الأقسام ({VISIBLE_GROUPS.length} مجموعة + {VISIBLE_TILES.filter((t) => !VISIBLE_TILE_PARENT_OF[t.id]).length} قسم)</span>
                  <button onClick={() => setShowTileMenu(false)} className="text-white/80 hover:text-white text-xs">إغلاق ✕</button>
                </div>
                <div className="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-3 tile-cascade" data-testid="admin-tile-grid">
                  {/* ORANGE GROUP TILES — render first, open a sub-list when clicked */}
                  {VISIBLE_GROUPS.map((g) => {
                    const childBadgeCount = g.children.reduce((sum, cid) => {
                      const t = ADMIN_TILES.find((x) => x.id === cid);
                      return sum + (t?.badge ? (t.badge(badges) || 0) : 0);
                    }, 0);
                    return (
                      <div key={g.id} className="relative group">
                        <button
                          onClick={() => setActiveGroupId(g.id)}
                          data-testid={`group-${g.id}`}
                          style={{ background: `linear-gradient(to left, ${g.color}, #dc9320)` }}
                          className="w-full relative text-white rounded-2xl shadow-lg hover:shadow-xl transition-all p-2 sm:p-5 flex flex-col items-center gap-1 sm:gap-2 min-h-[82px] sm:min-h-[110px] hover:-translate-y-1 ring-2 ring-[#F5A623]/40"
                        >
                          <g.icon className="w-5 h-5 sm:w-7 sm:h-7 mb-0.5 sm:mb-1" strokeWidth={1.8} />
                          <span className="font-bold text-[11px] sm:text-sm text-center leading-tight line-clamp-2">{g.label}</span>
                          <span className="text-[9px] sm:text-[10px] opacity-90 bg-white/20 px-1.5 sm:px-2 py-0.5 rounded-full" dir="ltr">
                            {g.children.length} أقسام
                          </span>
                          {childBadgeCount > 0 && (
                            <span className="absolute top-1 left-1 sm:top-2 sm:left-2 bg-white text-[#E85D45] text-[9px] sm:text-[10px] font-black w-5 h-5 sm:w-6 sm:h-6 rounded-full flex items-center justify-center animate-pulse" dir="ltr">
                              {childBadgeCount}
                            </span>
                          )}
                        </button>
                      </div>
                    );
                  })}

                  {/* Regular tiles — but skip those that belong to a group */}
                  {VISIBLE_TILES.filter((t) => !VISIBLE_TILE_PARENT_OF[t.id]).map((tile) => {
                    const ti = tileImages[tile.id];
                    const customImg = ti?.image_path ? `${API}/files/${ti.image_path}` : null;
                    const imgSize = ti?.size || 56;
                    // Special green gradient for the "حسابات الإدارة" liquidity dashboard —
                    // it's the master admin's most important financial glance card, so we
                    // make it visually distinct from the ordinary blue tiles.
                    const isGreenTile = tile.id === "admin-accounts";
                    const gradientClass = isGreenTile
                      ? "bg-gradient-to-l from-[#047857] to-[#10b981] hover:from-[#065f46] hover:to-[#059669]"
                      : "bg-gradient-to-l from-[#1E3A5F] to-[#3B82F6] hover:from-[#152a45] hover:to-[#2563EB]";
                    return (
                    <div key={tile.id} className="relative group">
                      <button
                        onClick={() => {
                          setActiveTab(tile.id);
                          setShowTileMenu(false);
                        }}
                        data-testid={`tile-${tile.id}`}
                        className={`w-full relative ${gradientClass} text-white rounded-2xl shadow-lg hover:shadow-xl transition-all p-2 sm:p-5 flex flex-col items-center gap-1 sm:gap-2 min-h-[82px] sm:min-h-[110px] hover:-translate-y-1`}
                      >
                        {customImg ? (
                          <img
                            src={customImg}
                            alt={tile.label}
                            style={{ width: imgSize, height: imgSize }}
                            className="object-contain rounded-lg mb-0.5 sm:mb-1 max-w-[36px] max-h-[36px] sm:max-w-none sm:max-h-none"
                          />
                        ) : (
                          <tile.icon className="w-5 h-5 sm:w-7 sm:h-7 mb-0.5 sm:mb-1" strokeWidth={1.8} />
                        )}
                        <span className="font-bold text-[11px] sm:text-sm text-center leading-tight line-clamp-2">{tile.label}</span>
                        {tile.badge && tile.badge(badges) > 0 && (
                          <span className="absolute top-1 left-1 sm:top-2 sm:left-2 bg-[#F5A623] text-[#111814] text-[9px] sm:text-[10px] font-black w-5 h-5 sm:w-6 sm:h-6 rounded-full flex items-center justify-center animate-pulse">
                            {tile.badge(badges)}
                          </span>
                        )}
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setTileImageEditor({ tile_id: tile.id, label: tile.label });
                        }}
                        data-testid={`tile-customize-${tile.id}`}
                        title="تخصيص صورة وحجم القسم"
                        className="absolute -top-1 -right-1 w-6 h-6 sm:w-7 sm:h-7 bg-white text-[#1E3A5F] hover:bg-[#F5A623] hover:text-white rounded-full shadow-lg flex items-center justify-center text-xs opacity-0 group-hover:opacity-100 transition-opacity z-10 border-2 border-[#3B82F6]"
                      >
                        <Edit2 className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
                      </button>
                    </div>
                    );
                  })}
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>



        {activeTab === "home" && stats && !showTileMenu && (
          <>
            {!isSubAdmin && <ProfitChart />}
            <div className="bg-gradient-to-l from-[#1E3A5F]/10 to-[#3B82F6]/10 border border-[#3B82F6]/30 rounded-2xl p-4 text-center">
              <p className="text-sm text-[#1E3A5F] font-bold">
                👆 اضغط زر <span className="inline-block bg-[#E85D45] text-white rounded-lg px-2 py-0.5 mx-1">🏠 البيت</span> فوق لاستعراض كل الأقسام ({ADMIN_TILES.length})
              </p>
            </div>
          </>
        )}

        {activeTab !== "home" && (
          <>
            {/* Section card wrapper */}
            <div className="bg-gradient-to-l from-[#1E3A5F] to-[#3B82F6] text-white rounded-2xl px-5 py-3 flex items-center justify-between shadow-md" data-testid="section-header">
              <h2 className="font-heading font-bold text-lg">{TAB_LABELS[activeTab]}</h2>
              <button onClick={() => { setActiveTab("home"); setShowTileMenu(true); }}
                className="bg-white/20 hover:bg-white/30 text-white text-xs font-bold px-3 py-1.5 rounded-full">
                ↩ كل الأقسام
              </button>
            </div>
            <div className="bg-[#E0F2FE] border border-[#3B82F6]/30 rounded-2xl p-4 shadow-sm" data-testid="section-content">
        {activeTab === "profits" ? (
          <ProfitsTab />
        ) : activeTab === "inventory" ? (
          <InventoryReport refreshTick={productsChangedTick} />
        ) : activeTab === "customer-statement" ? (
          <CustomerStatement />
        ) : activeTab === "account-balances" ? (
          <AccountBalances />
        ) : activeTab === "supplier-debts" ? (
          <SupplierDebtsTab />
        ) : activeTab === "driver-bundles" ? (
          <DriverBundlesTab />
        ) : activeTab === "customer-rewards" ? (
          <CustomerRewardsReport />
        ) : activeTab === "add-customer" ? (
          <AddCustomerTab />
        ) : activeTab === "policies" ? (
          <AdminPoliciesTab />
        ) : activeTab === "cash-box" ? (
          <CashBoxTab />
        ) : activeTab === "tiers" ? (
          <TiersTab />
        ) : activeTab === "market-ranking" ? (
          <MarketRankingTab />
        ) : activeTab === "top-markets-contest" ? (
          <TopMarketsTab />
        ) : activeTab === "customer-details" ? (
          <CustomerDetailsTab />
        ) : activeTab === "pending-customers" ? (
          <PendingCustomersTab />
        ) : activeTab === "pending-driver-orders" ? (
          <PendingDriverOrdersTab />
        ) : activeTab === "daily-log" ? (
          <DailyLogTab />
        ) : activeTab === "damaged-items" ? (
          <DamagedItemsTab />
        ) : activeTab === "stale-debts" ? (
          <StaleDebtsTab />
        ) : activeTab === "sales-report" ? (
          <SalesReportTab />
        ) : activeTab === "financial-activity" ? (
          <FinancialActivityTab />
        ) : activeTab === "slow-moving" ? (
          <SlowMovingProductsTab />
        ) : activeTab === "sales-invoices-report" ? (
          <SalesInvoicesReportTab />
        ) : activeTab === "purchases-report" ? (
          <PurchasesReportTab />
        ) : activeTab === "customers" ? (
          <CustomersTab />
        ) : activeTab === "customer-docs" ? (
          <CustomerDocsTab />
        ) : activeTab === "reps" ? (
          <RepsTab />
        ) : activeTab === "mandoobs" ? (
          <MandoobsTab />
        ) : activeTab === "withdrawals" ? (
          <WithdrawalsTab />
        ) : activeTab === "drivers" ? (
          <DriversTab />
        ) : activeTab === "mujahez" ? (
          <MujahezTab />
        ) : activeTab === "payment-confirms" ? (
          <PaymentConfirmationsTab />
        ) : activeTab === "cash-subs" ? (
          <CashSubmissionsTab />
        ) : activeTab === "returns" ? (
          <ReturnsTab />
        ) : activeTab === "receipt-voucher" ? (
          <ReceiptVoucher />
        ) : activeTab === "salaries" ? (
          <SalariesTab />
        ) : activeTab === "brands" ? (
          <BrandsTab />
        ) : activeTab === "debts" ? (
          <DebtPaymentsTab />
        ) : activeTab === "banners" ? (
          <BannersManager />
        ) : activeTab === "auto-backups" ? (
          <AutoBackupsTab />
        ) : activeTab === "employees" ? (
          <EmployeesTab />
        ) : activeTab === "employee-advances" ? (
          <EmployeeAdvancesTab />
        ) : activeTab === "purchase" ? (
          <PurchaseTab
            presetProductIdsFromBell={purchasePresetProductIds}
            onConsumedPreset={() => setPurchasePresetProductIds([])}
          />
        ) : activeTab === "material-movement" ? (
          <MaterialLedgerTab refreshTick={productsChangedTick} />
        ) : activeTab === "invoice-edits-log" ? (
          <InvoiceEditsLogTab />
        ) : activeTab === "orders-processing" ? (
          <OrdersProcessingTab />
        ) : activeTab === "sub-admins" ? (
          <SubAdminsTab
            availableTiles={ADMIN_TILES.filter((t) => t.id !== "sub-admins" && t.id !== "home").map((t) => ({ id: t.id, label: t.label }))}
            tileGroups={TILE_GROUPS.map((g) => ({ id: g.id, label: g.label, children: g.children, color: g.color }))}
            portalIcons={[
              { id: "portal-customer", label: "عرض كزبون", color: "#2D4A3E" },
              { id: "portal-driver", label: "عرض كسائق", color: "#E85D45" },
              { id: "portal-mujahez", label: "عرض كمجهّز", color: "#F5A623" },
              { id: "portal-rep", label: "عرض كمشرف", color: "#3B82F6" },
              { id: "portal-complaints", label: "الشكاوي والملاحظات", color: "#dc2626" },
            ]}
            homeWidgets={[
              { id: "widget-total-sales", label: "إجمالي المبيعات" },
              { id: "widget-total-received", label: "إجمالي المُستلَم" },
              { id: "widget-total-cartons", label: "إجمالي الكراتين" },
              { id: "widget-orders-done", label: "الطلبات المنجزة" },
              { id: "widget-orders-pending", label: "طلبات قيد الإنجاز" },
              { id: "widget-cumulative-profit", label: "إجمالي الأرباح (تراكمي)" },
              { id: "widget-capital", label: "رأس المال" },
              { id: "widget-today-sales", label: "ايش بعنا اليوم" },
            ]}
          />        ) : activeTab === "driver-ratings" ? (
          <DriverRatingsTab />
        ) : activeTab === "debt-audit" ? (
          <DebtAuditTab />
        ) : activeTab === "gifts" ? (
          <GiftsTab />
        ) : activeTab === "direct-sale" ? (
          <DirectSaleTab />
        ) : activeTab === "price-list" ? (
          <PriceListTab />
        ) : activeTab === "supplier-accounts" ? (
          <SupplierAccountsTab />
        ) : activeTab === "purchase-proposals" ? (
          <PurchaseProposalsTab />
        ) : activeTab === "ab-prices" ? (
          <AbPricesTab />
        ) : activeTab === "complaints" ? (
          <ComplaintsTab />
        ) : activeTab === "money-box" ? (
          <MoneyBoxTab />
        ) : activeTab === "sup-price-approvals" ? (
          <SupervisorPriceApprovalsTab />
        ) : activeTab === "capital" ? (
          <CapitalTab onChanged={fetchData} />
        ) : activeTab === "admin-accounts" ? (
          <AdminAccountsTab />
        ) : activeTab === "expenses" ? (
          <ExpensesTab onChanged={fetchData} />
        ) : activeTab === "vehicles" ? (
          <VehiclesTab />
        ) : activeTab === "products" ? (
          /* Products Management Tab — BRAND-FIRST */
          <div data-testid="products-management" className="space-y-4">
            {!selectedProductBrand ? (
              // ===== Brand selector view =====
              <>
                <div className="bg-white rounded-2xl p-4 border-2 border-[#1E3A5F]/20 shadow-md">
                  <div className="flex justify-between items-center flex-wrap gap-3 mb-3">
                    <h3 className="font-heading font-bold text-xl text-[#1E3A5F] flex items-center gap-2">
                      <Building2 className="w-5 h-5" />اختر الشركة لعرض/إضافة منتجاتها
                    </h3>
                  </div>
                  <div className="relative mb-4">
                    <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#5C6E64]" />
                    <input
                      type="text"
                      value={productsBrandSearch}
                      onChange={(e) => setProductsBrandSearch(e.target.value)}
                      placeholder="ابحث عن شركة... (مثال: البوادي)"
                      data-testid="products-brand-search"
                      className="w-full pr-9 pl-4 py-2.5 rounded-full bg-[#F3F6F4] border border-[#E4EBE6] text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]"
                    />
                  </div>

                  {(() => {
                    const q = productsBrandSearch.trim().toLowerCase();
                    const filtered = productsBrands.filter((b) =>
                      !q || (b.name_ar || "").toLowerCase().includes(q) || (b.category || "").toLowerCase().includes(q)
                    );
                    const orphanCount = products.filter((p) => !p.brand_id).length;
                    if (filtered.length === 0 && !q) {
                      return (
                        <div className="text-center py-12 text-[#5C6E64]">
                          <Building2 className="w-12 h-12 mx-auto mb-2 opacity-50" />
                          <p className="mb-3">لا توجد شركات بعد</p>
                          <button
                            onClick={() => setActiveTab("brands")}
                            data-testid="goto-brands-from-products"
                            className="bg-[#1E3A5F] hover:bg-[#152a45] text-white font-bold px-5 py-2 rounded-full inline-flex items-center gap-2"
                          >
                            <Plus className="w-4 h-4" />أضف شركة أولاً
                          </button>
                        </div>
                      );
                    }
                    return (
                      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                        {filtered.map((b) => (
                          <button
                            key={b.id}
                            onClick={() => setSelectedProductBrand(b)}
                            data-testid={`products-brand-tile-${b.id}`}
                            className="bg-white border-2 border-[#BAE6FD] hover:border-[#3B82F6] hover:shadow-lg rounded-2xl p-3 transition-all text-right"
                          >
                            <div className="aspect-square flex items-center justify-center mb-2 bg-gradient-to-br from-[#F0F9FF] to-[#E0F2FE] rounded-xl overflow-hidden">
                              {b.image_path ? (
                                <img src={`${API}/files/${b.image_path}`} alt={b.name_ar} className="w-full h-full object-contain" />
                              ) : (
                                <Building2 className="w-12 h-12 text-[#3B82F6]" />
                              )}
                            </div>
                            <p className="font-bold text-[#1E3A5F] text-sm text-center truncate">{b.name_ar}</p>
                            <p className="text-[10px] text-[#5C6E64] text-center mt-0.5">
                              {b.category} • <span dir="ltr">{b.product_count}</span> منتج
                            </p>
                          </button>
                        ))}
                        {/* Orphan products tile (no brand) */}
                        {orphanCount > 0 && (
                          <button
                            onClick={() => setSelectedProductBrand({ id: "__none__", name_ar: "بدون شركة", category: null })}
                            data-testid="products-brand-tile-none"
                            className="bg-gradient-to-br from-[#5C6E64] to-[#3a4a40] text-white rounded-2xl p-3 hover:shadow-lg transition-all"
                          >
                            <div className="aspect-square flex flex-col items-center justify-center">
                              <Package className="w-12 h-12 opacity-80 mb-1" />
                              <p className="font-bold text-sm">بدون شركة</p>
                              <p className="text-[10px] opacity-80 mt-0.5" dir="ltr">{orphanCount} منتج</p>
                            </div>
                          </button>
                        )}
                      </div>
                    );
                  })()}
                </div>
              </>
            ) : (
              // ===== Products of selected brand =====
              <>
                <div className="bg-white rounded-2xl p-4 border-2 border-[#1E3A5F]/20 shadow-md">
                  <div className="flex items-center gap-3 mb-3">
                    <button
                      onClick={() => setSelectedProductBrand(null)}
                      data-testid="products-back-to-brands"
                      className="p-2 hover:bg-[#F3F6F4] rounded-full transition-colors"
                      title="رجوع إلى الشركات"
                    >
                      <ArrowRight className="w-5 h-5 text-[#1E3A5F]" />
                    </button>
                    <div className="flex-1">
                      <h3 className="font-heading font-bold text-lg text-[#1E3A5F] flex items-center gap-2">
                        <Building2 className="w-5 h-5" />
                        منتجات شركة {selectedProductBrand.name_ar}
                      </h3>
                      {selectedProductBrand.category && (
                        <p className="text-xs text-[#5C6E64]">القسم: {selectedProductBrand.category}</p>
                      )}
                    </div>
                    <button
                      onClick={() => setLowStockBrand({
                        id: selectedProductBrand.id,
                        name_ar: selectedProductBrand.name_ar,
                        color: "#F5A623",
                      })}
                      data-testid="low-stock-alert-btn"
                      title="قائمة النواقص"
                      className="relative flex items-center gap-1.5 bg-gradient-to-l from-[#F5A623] to-[#E85D45] hover:from-[#E85D45] hover:to-[#F5A623] text-white font-bold px-3 py-2 rounded-full transition-all text-sm shadow-md"
                    >
                      <AlertTriangle className="w-4 h-4" />
                      النواقص
                    </button>
                    <button
                      onClick={() => {
                        setProductToEdit(null);
                        // For orphan brand id "__none__", do not preselect
                        setPreselectedBrandForNew(
                          selectedProductBrand.id === "__none__"
                            ? null
                            : {
                                id: selectedProductBrand.id,
                                name_ar: selectedProductBrand.name_ar,
                                category: selectedProductBrand.category,
                                categories: selectedProductBrand.categories || [],
                                product_count: selectedProductBrand.product_count,
                              }
                        );
                        setShowProductForm(true);
                      }}
                      data-testid="add-product-btn"
                      className="flex items-center gap-2 bg-[#E85D45] hover:bg-[#d54d35] text-white font-bold px-4 py-2 rounded-full transition-colors text-sm"
                    >
                      <Plus className="w-4 h-4" />إضافة منتج
                    </button>
                  </div>

                  {/* ⭐ Featured Quick-Actions Panel (yellow) — bulk offer add/remove
                      + rapid multi-product add. Requested Feb 27, 2026. Only
                      shows on real brands (not the "بدون شركة" orphan bucket). */}
                  {selectedProductBrand.id !== "__none__" && (
                    <div
                      data-testid="brand-quick-actions"
                      className="mt-3 relative overflow-hidden rounded-2xl border-2 border-[#F5A623] bg-gradient-to-br from-[#FFFBEB] via-[#FEF3C7] to-[#FDE68A] p-3 sm:p-4"
                    >
                      {/* animated star — moves diagonally, subtle sparkle */}
                      <motion.div
                        aria-hidden
                        initial={{ x: 0, y: 0, rotate: 0 }}
                        animate={{ x: [0, 8, -4, 0], y: [0, -6, 4, 0], rotate: [0, 15, -10, 0] }}
                        transition={{ duration: 3.5, repeat: Infinity, ease: "easeInOut" }}
                        className="absolute -top-2 -right-2 text-[#F59E0B] drop-shadow-[0_2px_4px_rgba(245,158,11,0.4)] pointer-events-none"
                      >
                        <Star className="w-10 h-10 fill-[#F59E0B]" />
                      </motion.div>
                      <motion.div
                        aria-hidden
                        initial={{ opacity: 0.6, scale: 1 }}
                        animate={{ opacity: [0.6, 1, 0.6], scale: [1, 1.15, 1] }}
                        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                        className="absolute top-6 right-8 text-[#F59E0B] pointer-events-none"
                      >
                        <Star className="w-3 h-3 fill-[#F59E0B]" />
                      </motion.div>

                      <div className="relative flex items-center gap-2 mb-2.5">
                        <div className="bg-white/70 backdrop-blur-sm rounded-full p-1.5 border border-[#F59E0B]/40">
                          <Star className="w-4 h-4 text-[#B45309] fill-[#F59E0B]" />
                        </div>
                        <h4 className="font-black text-sm sm:text-base text-[#78350F]">مميزات سريعة لهذه الشركة</h4>
                      </div>

                      <div className="relative grid grid-cols-1 sm:grid-cols-3 gap-2">
                        <button
                          onClick={() => setOffersPickerBrand(selectedProductBrand)}
                          data-testid="bulk-add-offers-btn"
                          className="bg-white hover:bg-[#FEF9C3] border-2 border-[#F59E0B] text-[#78350F] font-black text-xs sm:text-sm rounded-xl px-3 py-2.5 flex items-center justify-center gap-1.5 shadow-sm transition-all hover:shadow-md hover:scale-[1.02] active:scale-95"
                        >
                          <Star className="w-4 h-4 fill-[#F59E0B] text-[#F59E0B]" />
                          إضافة العروض
                        </button>

                        <button
                          onClick={async () => {
                            if (brandOfferBusy) return;
                            if (!(await confirmDialog(`حذف كل العروض من منتجات "${selectedProductBrand.name_ar}"؟\n\nراح تنشال علامة "عرض" من كل المنتجات.`))) return;
                            setBrandOfferBusy(true);
                            try {
                              const { data } = await axios.post(`${API}/admin/brands/${selectedProductBrand.id}/clear-all-offer`);
                              toast.success(`🗑️ تم حذف العروض من ${data.updated} منتج`);
                              fetchData();
                            } catch (e) {
                              toast.error(e.response?.data?.detail || "فشل التطبيق");
                            } finally { setBrandOfferBusy(false); }
                          }}
                          disabled={brandOfferBusy}
                          data-testid="bulk-clear-offers-btn"
                          className="bg-white hover:bg-[#FEE2E2] disabled:opacity-60 border-2 border-[#E85D45] text-[#7F1D1D] font-black text-xs sm:text-sm rounded-xl px-3 py-2.5 flex items-center justify-center gap-1.5 shadow-sm transition-all hover:shadow-md hover:scale-[1.02] active:scale-95"
                        >
                          <X className="w-4 h-4" />
                          حذف العروض الكاملة
                        </button>

                        <button
                          onClick={() => {
                            setProductToEdit(null);
                            setPreselectedBrandForNew({
                              id: selectedProductBrand.id,
                              name_ar: selectedProductBrand.name_ar,
                              category: selectedProductBrand.category,
                              categories: selectedProductBrand.categories || [],
                              product_count: selectedProductBrand.product_count,
                            });
                            setBulkAddMode(true);
                            setShowProductForm(true);
                          }}
                          data-testid="bulk-add-products-btn"
                          className="bg-white hover:bg-[#DCFCE7] border-2 border-[#16A34A] text-[#166534] font-black text-xs sm:text-sm rounded-xl px-3 py-2.5 flex items-center justify-center gap-1.5 shadow-sm transition-all hover:shadow-md hover:scale-[1.02] active:scale-95"
                        >
                          <Plus className="w-4 h-4" />
                          إضافة منتجات متكررة
                        </button>
                      </div>

                      <p className="relative text-[10px] sm:text-[11px] text-[#78350F]/80 mt-2 leading-snug">
                        💡 «إضافة منتجات متكررة» — من تدوس حفظ، الشاشة ما تنسكر، بس تفرغ الحقول عشان تضيف منتج ثاني فوراً. اضغط ✕ لما تخلص.
                      </p>
                    </div>
                  )}

                  {/* Filter chips */}
                  <div className="flex gap-2 overflow-x-auto pb-1">
                    {[
                      { key: "all", label: "الكل" },
                      { key: "offer", label: "⚡ العروضات" },
                      { key: "bestseller", label: "⭐ الأكثر مبيعاً" },
                      { key: "win", label: "🎁 اطلب واربح" },
                    ].map((f) => (
                      <button
                        key={f.key}
                        onClick={() => setProductFilter(f.key)}
                        data-testid={`product-filter-${f.key}`}
                        className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors ${
                          productFilter === f.key
                            ? "bg-[#2D4A3E] text-white"
                            : "bg-[#F3F6F4] text-[#5C6E64] border border-[#E4EBE6] hover:bg-white"
                        }`}
                      >
                        {f.label}
                      </button>
                    ))}
                  </div>

                  {/* 🔍 Precise product search inside this brand — supports messy
                      Arabic (ignores hamza/tashkeel + normalizes Arabic digits).
                      Also matches SKU/barcode + tags so admin can find any item fast. */}
                  <div className="relative mt-3">
                    <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#5C6E64]" />
                    <input
                      type="text"
                      value={productsInBrandSearch}
                      onChange={(e) => setProductsInBrandSearch(e.target.value)}
                      placeholder={`🔍 ابحث داخل منتجات ${selectedProductBrand.name_ar}... (مثال: دجاج، بيض، 25، باركود...)`}
                      data-testid="products-in-brand-search"
                      className="w-full pr-9 pl-9 py-2.5 rounded-full bg-[#F3F6F4] border border-[#E4EBE6] text-sm focus:outline-none focus:ring-2 focus:ring-[#E85D45] transition-all"
                    />
                    {productsInBrandSearch && (
                      <button
                        onClick={() => setProductsInBrandSearch("")}
                        data-testid="products-in-brand-search-clear"
                        title="مسح البحث"
                        className="absolute left-2 top-1/2 -translate-y-1/2 p-1 rounded-full hover:bg-[#E4EBE6] text-[#5C6E64]"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    )}
                  </div>
                </div>

                {/* Brand-filtered products grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {(() => {
                    const q = productsInBrandSearch.trim();
                    const filtered = products.filter((p) => {
                      // Brand scope
                      if (selectedProductBrand.id === "__none__") {
                        if (p.brand_id) return false;
                      } else if (p.brand_id !== selectedProductBrand.id) {
                        return false;
                      }
                      // Filter chip
                      if (productFilter === "offer" && !p.is_offer) return false;
                      if (productFilter === "bestseller" && !p.is_best_seller) return false;
                      if (productFilter === "win" && !p.is_win) return false;
                      // 🔍 Precise search — Arabic-tolerant across every field
                      // the admin might type: Arabic name, English name, SKU,
                      // barcode, category, tags, weight/size text, description.
                      if (q) {
                        const hay = [
                          p.name_ar, p.name_en, p.name,
                          p.category, p.subcategory,
                          p.sku, p.barcode,
                          p.weight, p.size, p.unit,
                          p.description, p.notes,
                          Array.isArray(p.tags) ? p.tags.join(" ") : p.tags,
                        ].filter(Boolean).join(" ");
                        if (!smartMatch(hay, q)) return false;
                      }
                      return true;
                    });
                    if (filtered.length === 0) {
                      return (
                        <div className="col-span-full text-center py-16 bg-white rounded-2xl border-2 border-dashed border-[#E4EBE6]">
                          <Search className="w-12 h-12 mx-auto mb-2 text-[#5C6E64] opacity-50" />
                          <p className="text-[#5C6E64] font-medium">
                            {q ? `لا توجد منتجات تطابق "${q}"` : "لا توجد منتجات لهذه الشركة"}
                          </p>
                          {q && (
                            <button
                              onClick={() => setProductsInBrandSearch("")}
                              className="mt-3 text-[#E85D45] font-bold text-sm underline"
                            >
                              مسح البحث
                            </button>
                          )}
                        </div>
                      );
                    }
                    return filtered.map((product) => {
                      const stock = product.stock ?? 0;
                      const isOut = stock === 0;
                      return (
                        <motion.div
                          key={product.id}
                          initial={{ opacity: 0, y: 10 }}
                          animate={{ opacity: 1, y: 0 }}
                          data-testid={`product-card-${product.id}`}
                          className={`bg-white border rounded-2xl p-4 space-y-3 ${
                            isOut ? "border-[#E85D45]/40" : "border-[#E4EBE6]"
                          }`}
                        >
                          <div className="flex gap-3">
                            <div
                              className="w-20 h-20 rounded-xl flex items-center justify-center flex-shrink-0 overflow-hidden"
                              style={{ backgroundColor: product.color }}
                            >
                              {product.image_path ? (
                                <img
                                  src={`${API}/files/${product.image_path}`}
                                  alt={product.name_ar}
                                  className="w-full h-full object-cover"
                                />
                              ) : (
                                <span className="font-bold text-xs text-center px-1">
                                  {product.name_ar.slice(0, 8)}
                                </span>
                              )}
                            </div>
                            <div className="flex-1 min-w-0">
                              <h3 className="font-bold text-[#111814] truncate flex items-center gap-1.5">
                                {(() => {
                                  // Green dot if stock was manually edited within the last 30 days,
                                  // red otherwise. Helps admin see at a glance which items were
                                  // touched during this month's physical count.
                                  const editedAt = product.stock_manually_edited_at;
                                  let isRecent = false;
                                  if (editedAt) {
                                    const ts = new Date(editedAt).getTime();
                                    const thirtyDays = 30 * 24 * 60 * 60 * 1000;
                                    isRecent = !isNaN(ts) && (Date.now() - ts) <= thirtyDays;
                                  }
                                  return (
                                    <span
                                      data-testid={`stock-edit-dot-${product.id}`}
                                      title={isRecent ? "تم تعديل المخزون خلال آخر شهر" : "لم يتم تعديل المخزون يدوياً"}
                                      className={`inline-block w-2 h-2 rounded-full flex-shrink-0 ${
                                        isRecent ? "bg-[#7ED321]" : "bg-[#E85D45]"
                                      }`}
                                    />
                                  );
                                })()}
                                <span className="truncate">{product.name_ar}</span>
                              </h3>
                              <p className="text-xs text-[#5C6E64] truncate">{product.name}</p>
                              <div className="flex items-center gap-2 mt-1 flex-wrap">
                                <p className="font-bold text-[#2D4A3E]">{Number(product.price).toLocaleString("en-US", { maximumFractionDigits: 0 })} د.ع</p>
                                {product.cost_price > 0 && (
                                  <p className="text-xs text-[#4A90E2]">
                                    (شراء: {Number(product.cost_price).toLocaleString("en-US", { maximumFractionDigits: 0 })})
                                  </p>
                                )}
                              </div>
                              <div className="flex gap-1 mt-1 flex-wrap">
                                {product.is_offer && (
                                  <span className="text-[10px] px-2 py-0.5 bg-[#F5A623]/20 text-[#F5A623] rounded-full">عرض</span>
                                )}
                                {product.is_offer && product.featured_offer_slot && (
                                  <span
                                    data-testid={`product-featured-slot-badge-${product.id}`}
                                    className="text-[10px] px-2 py-0.5 bg-gradient-to-br from-[#F5A623] to-[#E85D45] text-white rounded-full font-black"
                                    title={`عرض مميز — الموضع رقم ${product.featured_offer_slot}`}
                                  >
                                    ⭐ {product.featured_offer_slot}
                                  </span>
                                )}
                                {product.is_best_seller && (
                                  <span className="text-[10px] px-2 py-0.5 bg-[#2D4A3E]/20 text-[#2D4A3E] rounded-full">مبيعاً</span>
                                )}
                                {product.is_win && (
                                  <span className="text-[10px] px-2 py-0.5 bg-[#E85D45]/20 text-[#E85D45] rounded-full">جائزة</span>
                                )}
                                {product.excludes_rewards && (
                                  <span
                                    data-testid={`product-no-reward-badge-${product.id}`}
                                    className="text-[10px] px-2 py-0.5 bg-[#DC2626]/15 text-[#DC2626] rounded-full font-bold"
                                    title="مستثنى من خصم/مكافأة الفئة"
                                  >
                                    🚫 بلا خصم
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className={`rounded-xl p-3 ${isOut ? "bg-[#E85D45]/10" : "bg-[#F3F6F4]"}`}>
                            <p className="text-xs text-[#5C6E64] mb-1">الكمية المتوفرة</p>
                            {editingProduct === product.id ? (
                              <div className="flex items-center gap-2">
                                <input
                                  type="number"
                                  min="0"
                                  value={editStock}
                                  onChange={(e) => setEditStock(e.target.value)}
                                  data-testid={`stock-input-${product.id}`}
                                  className="flex-1 px-3 py-2 rounded-lg border border-[#E4EBE6] focus:outline-none focus:ring-2 focus:ring-[#2D4A3E] bg-white"
                                  autoFocus
                                />
                                <button
                                  onClick={() => handleSaveStock(product.id)}
                                  data-testid={`save-stock-${product.id}`}
                                  className="p-2 bg-[#7ED321] hover:bg-[#6cb91d] text-white rounded-lg transition-colors"
                                >
                                  <Save className="w-4 h-4" />
                                </button>
                                <button
                                  onClick={() => { setEditingProduct(null); setEditStock(""); }}
                                  data-testid={`cancel-stock-${product.id}`}
                                  className="p-2 bg-[#F3F6F4] hover:bg-[#E4EBE6] text-[#5C6E64] rounded-lg transition-colors"
                                >
                                  <X className="w-4 h-4" />
                                </button>
                              </div>
                            ) : (
                              <div className="flex items-center justify-between">
                                <span
                                  data-testid={`stock-value-${product.id}`}
                                  className={`font-bold text-xl ${
                                    isOut ? "text-[#E85D45]" : stock > 20 ? "text-[#7ED321]" : "text-[#F5A623]"
                                  }`}
                                >
                                  {isOut ? "غير متوفر" : `متوفر ${stock}`}
                                </span>
                                <button
                                  onClick={() => { setEditingProduct(product.id); setEditStock(String(stock)); }}
                                  data-testid={`edit-stock-${product.id}`}
                                  className="p-2 bg-[#2D4A3E] hover:bg-[#233A30] text-white rounded-lg transition-colors"
                                >
                                  <Edit3 className="w-4 h-4" />
                                </button>
                              </div>
                            )}
                          </div>

                          <div className="flex gap-2">
                            <button
                              onClick={() => { setProductToEdit(product); setPreselectedBrandForNew(null); setShowProductForm(true); }}
                              data-testid={`edit-product-${product.id}`}
                              className="flex-1 flex items-center justify-center gap-1 bg-[#4A90E2] hover:bg-[#3a7bc4] text-white font-medium py-2 rounded-full text-sm transition-colors"
                            >
                              <Edit3 className="w-3 h-3" />تعديل
                            </button>
                            <button
                              onClick={() => handleDeleteProduct(product.id, product.name_ar)}
                              data-testid={`delete-product-${product.id}`}
                              className="flex-1 flex items-center justify-center gap-1 bg-[#E85D45] hover:bg-[#d54d35] text-white font-medium py-2 rounded-full text-sm transition-colors"
                            >
                              <Trash2 className="w-3 h-3" />حذف
                            </button>
                          </div>
                        </motion.div>
                      );
                    });
                  })()}
                </div>
              </>
            )}
          </div>
        ) : (
          <>
            {/* Filter Tabs + Reset Button */}
            <div className="flex justify-between items-center flex-wrap gap-3 pb-2">
              <div className="flex gap-2 overflow-x-auto items-center">
                {/* Shaking bell — visible only when a brand-new pending order
                    has arrived. Auto-disappears after 6s. Click to silence. */}
                {newOrderRing && (
                  <button
                    type="button"
                    onClick={() => setNewOrderRing(false)}
                    data-testid="new-order-ring-bell"
                    title="طلب جديد وصل — اضغط للإخفاء"
                    className="shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#E85D45] text-white font-bold text-xs shadow-lg animate-jumlaty-shake"
                    style={{ boxShadow: "0 0 0 4px rgba(232,93,69,0.25)" }}
                  >
                    <Bell className="w-4 h-4" />
                    طلب جديد!
                  </button>
                )}
                {(activeTab === "orders-confirmed"
                  ? [
                      { key: "all", label: "الكل" },
                      { key: "confirmed", label: "تم الموافقة" },
                      { key: "mujahez_assigned", label: "عند المجهّز" },
                      { key: "delivering", label: "قيد التوصيل" },
                      { key: "delivered", label: "تم التوصيل" },
                    ]
                  : [
                      { key: "all", label: "الكل" },
                      { key: "pending", label: "قيد المعالجة" },
                      { key: "rejected", label: "مرفوض" },
                    ]
                ).map((f) => (
                  <button
                    key={f.key}
                    onClick={() => setFilter(f.key)}
                    data-testid={`filter-${f.key}`}
                    className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
                      filter === f.key
                        ? "bg-[#2D4A3E] text-white"
                        : "bg-white text-[#5C6E64] border border-[#E4EBE6] hover:bg-[#F3F6F4]"
                    }`}
                  >
                    {f.label}
                  </button>
                ))}
              </div>
              {activeTab !== "orders-confirmed" && (
                <BulkApproveButton
                  resource="orders"
                  label="موافقة على كل الطلبات"
                  count={orders.filter((o) => o.status === "pending").length}
                  onDone={fetchData}
                />
              )}
              {/* Bulk-confirm supervisor invoices — only on the Pending tab */}
              {activeTab !== "orders-confirmed" && filteredOrders.some((o) => o.awaiting_admin_confirmation) && (
                <button
                  type="button"
                  onClick={confirmAllSupervisorSales}
                  data-testid="bulk-confirm-supervisor-btn"
                  title="موافقة الإدارة على كل فواتير المشرف الظاهرة دفعة واحدة"
                  className="bg-[#15803D] hover:bg-[#126b32] text-white text-xs sm:text-sm font-bold px-3 sm:px-4 py-2 rounded-full flex items-center gap-1.5 transition-colors shadow"
                >
                  ✓ تأكيد فواتير المشرف ({filteredOrders.filter((o) => o.awaiting_admin_confirmation).length})
                </button>
              )}
              {/* Bulk-hide visible invoices in the active tab — SAFETY: on the pending
                  tab, pending/awaiting-supervisor orders are protected and NEVER hidden. */}
              {(() => {
                if (filteredOrders.length === 0) return null;
                const scope = activeTab === "orders-confirmed" ? "confirmed" : "pending";
                const hideable = scope === "confirmed"
                  ? filteredOrders.length
                  : filteredOrders.filter((o) => o.status !== "pending" && !(o.awaiting_admin_confirmation && o.is_supervisor_sale)).length;
                if (hideable === 0) return null;
                return (
                  <button
                    type="button"
                    onClick={hideAllOrders}
                    data-testid="bulk-hide-orders-btn"
                    title={scope === "pending"
                      ? "إخفاء كل الفواتير المرفوضة من اللوحة (الطلبات المعلّقة محميّة ولن تُخفى)"
                      : "إخفاء كل الفواتير الظاهرة من اللوحة (تبقى محفوظة وقابلة للبحث)"}
                    className="bg-[#E85D45] hover:bg-[#d54d35] text-white text-xs sm:text-sm font-bold px-3 sm:px-4 py-2 rounded-full flex items-center gap-1.5 transition-colors shadow"
                  >
                    ✕ إخفاء {scope === "pending" ? "المرفوضة" : "الكل"} من اللوحة ({hideable})
                  </button>
                );
              })()}
              {/* 🛡️ EMERGENCY: restore any active orders that were accidentally hidden. */}
              {activeTab !== "orders-confirmed" && (
                <button
                  type="button"
                  onClick={async () => {
                    const ok = await confirmDialog(
                      "استرجاع كل الفواتير النشطة (المعلّقة + فواتير المشرف بانتظار التأكيد) التي أُخفيت سابقاً؟\n\nيستخدم هذا الزر عندما تختفي طلبات جديدة من اللوحة عن طريق الخطأ."
                    );
                    if (!ok) return;
                    try {
                      const { data } = await axios.post(`${API}/admin/orders/restore-hidden-active`);
                      toast.success(data?.message || `تم الاسترجاع (${data?.restored ?? 0})`);
                      fetchData();
                    } catch (e) {
                      toast.error(e?.response?.data?.detail || "فشل الاسترجاع");
                    }
                  }}
                  data-testid="restore-hidden-active-btn"
                  title="استرجاع الفواتير المعلّقة المخفية عن طريق الخطأ"
                  className="bg-[#0EA5E9] hover:bg-[#0284C7] text-white text-xs sm:text-sm font-bold px-3 sm:px-4 py-2 rounded-full flex items-center gap-1.5 transition-colors shadow"
                >
                  ⟲ استرجاع الفواتير المخفية
                </button>
              )}
              <button
                type="button"
                onClick={() => setHistoryQuery({ initial: "" })}
                data-testid="open-customer-history"
                className="bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-xs sm:text-sm font-bold px-3 sm:px-4 py-2 rounded-full flex items-center gap-1.5 transition-colors shadow"
                title="بحث الفواتير برقم/اسم/هاتف الزبون مع إمكانية تطبيق خصم"
              >
                📜 كشف فواتير الزبون
              </button>
            </div>

            {/* Search + Date filter bar */}
            <div className="bg-white rounded-2xl p-3 border-2 border-[#1E3A5F]/20 shadow-sm space-y-2">
              <div className="relative">
                <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#5C6E64]" />
                <input
                  type="text"
                  value={orderSearch}
                  onChange={(e) => setOrderSearch(e.target.value)}
                  data-testid="order-search-input"
                  placeholder="ابحث برقم الايباد أو اسم الزبون أو الماركت أو رقم الهاتف..."
                  className="w-full pr-9 pl-4 py-2 rounded-full bg-[#F3F6F4] border border-[#E4EBE6] text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]"
                />
              </div>
              <div className="flex items-center gap-2 flex-wrap text-xs">
                <span className="text-[#5C6E64] font-medium">📅 التاريخ:</span>
                {[
                  { key: "all", label: "الكل" },
                  { key: "today", label: "اليوم" },
                  { key: "range", label: "نطاق محدد" },
                ].map((d) => (
                  <button
                    key={d.key}
                    onClick={() => setOrderDateFilter(d.key)}
                    data-testid={`order-date-${d.key}`}
                    className={`px-3 py-1.5 rounded-full font-medium transition-colors ${
                      orderDateFilter === d.key
                        ? "bg-[#1E3A5F] text-white"
                        : "bg-[#F3F6F4] text-[#5C6E64] border border-[#E4EBE6] hover:bg-white"
                    }`}
                  >
                    {d.label}
                  </button>
                ))}
                {orderDateFilter === "range" && (
                  <>
                    <input
                      type="date"
                      value={orderDateFrom}
                      onChange={(e) => setOrderDateFrom(e.target.value)}
                      data-testid="order-date-from"
                      className="bg-[#F3F6F4] border border-[#E4EBE6] rounded-full px-3 py-1.5 text-xs"
                    />
                    <span className="text-[#5C6E64]">→</span>
                    <input
                      type="date"
                      value={orderDateTo}
                      onChange={(e) => setOrderDateTo(e.target.value)}
                      data-testid="order-date-to"
                      className="bg-[#F3F6F4] border border-[#E4EBE6] rounded-full px-3 py-1.5 text-xs"
                    />
                  </>
                )}
                <span className="ml-auto text-[#5C6E64] font-bold" dir="ltr">
                  {filteredOrders.length} نتيجة
                </span>
              </div>
            </div>

        {/* View toggle + day navigation (compact mode only). Feb 2026 — added
            per admin request: spreadsheet-like row layout + arrows to navigate
            to previous days. Click the edit pencil to open the full colored
            invoice card. */}
        {activeTab === "orders" && (
          <BulkConfirmPrintButton />
        )}

        {(activeTab === "orders" || activeTab === "orders-confirmed") && (
          <div className="bg-white border border-[#E4EBE6] rounded-2xl p-2 mb-3 flex items-center gap-2 flex-wrap" data-testid="orders-view-toolbar">
            <div className="flex items-center bg-[#F3F6F4] rounded-full p-0.5" data-testid="orders-view-toggle">
              <button
                onClick={() => setOrdersView("compact")}
                data-testid="view-compact-btn"
                className={`text-xs font-bold px-3 py-1 rounded-full transition-colors ${
                  ordersView === "compact" ? "bg-[#1E3A5F] text-white" : "text-[#5C6E64]"
                }`}
              >
                📋 جدولي
              </button>
              <button
                onClick={() => setOrdersView("cards")}
                data-testid="view-cards-btn"
                className={`text-xs font-bold px-3 py-1 rounded-full transition-colors ${
                  ordersView === "cards" ? "bg-[#1E3A5F] text-white" : "text-[#5C6E64]"
                }`}
              >
                🃏 بطاقات
              </button>
            </div>
            {ordersView === "compact" && (
              <div className="flex items-center gap-2 ml-auto" dir="rtl">
                <span className="text-xs text-[#5C6E64] font-bold">عرض القوائم قبل</span>
                <div className="flex items-center gap-1 bg-[#FFF8EC] border-2 border-[#F5A623]/30 rounded-full px-2 py-0.5">
                  <button
                    onClick={() => setDayOffset((d) => Math.max(0, d - 1))}
                    data-testid="day-offset-down"
                    disabled={dayOffset === 0}
                    title="اليوم التالي"
                    className="text-[#92400E] hover:bg-[#FEF3C7] disabled:opacity-30 rounded-full w-6 h-6 flex items-center justify-center font-black"
                  >▼</button>
                  <span
                    data-testid="day-offset-value"
                    className="text-base font-black text-[#92400E] tabular-nums w-6 text-center"
                    dir="ltr"
                  >{dayOffset}</span>
                  <button
                    onClick={() => setDayOffset((d) => d + 1)}
                    data-testid="day-offset-up"
                    title="اليوم السابق"
                    className="text-[#92400E] hover:bg-[#FEF3C7] rounded-full w-6 h-6 flex items-center justify-center font-black"
                  >▲</button>
                </div>
                <span className="text-xs text-[#5C6E64]">يوم</span>
                {dayOffset > 0 && (
                  <button
                    onClick={() => setDayOffset(0)}
                    data-testid="day-offset-reset"
                    className="text-[10px] font-bold text-[#3B82F6] bg-[#E0F2FE] px-2 py-1 rounded-full"
                  >← اليوم</button>
                )}
              </div>
            )}
            {(activeTab === "orders-confirmed" || activeTab === "orders") && (
              <div className={ordersView === "compact" ? "" : "ml-auto"}>
                <AggregatePickListButton
                  selectMode={picklistSelectMode}
                  setSelectMode={(v) => { setPicklistSelectMode(v); if (!v) setPicklistSelectedIds([]); }}
                  selectedIds={picklistSelectedIds}
                  orders={filteredOrders}
                  onDone={() => { setPicklistSelectedIds([]); fetchData(); }}
                />
              </div>
            )}
          </div>
        )}

        {/* Compact table view — spreadsheet-like row layout */}
        {(activeTab === "orders" || activeTab === "orders-confirmed") && ordersView === "compact" ? (
          <div className="bg-white rounded-2xl border-2 border-[#E4EBE6] overflow-hidden" data-testid="orders-compact-table">
            <div className="grid grid-cols-[40px_80px_110px_1fr_50px] gap-2 px-3 py-2 bg-gradient-to-l from-[#1E3A5F] to-[#3B82F6] text-white text-xs font-black sticky top-0 z-10">
              <span className="text-center">ت</span>
              <span className="text-center">الرقم</span>
              <span className="text-center">التاريخ</span>
              <span>اسم الزبون</span>
              <span className="text-center">عرض</span>
            </div>
            {filteredOrders.length === 0 ? (
              <div className="text-center py-10 text-[#5C6E64]" data-testid="orders-compact-empty">
                <Package className="w-10 h-10 mx-auto opacity-30 mb-1" />
                لا توجد طلبات بهذه الفترة
              </div>
            ) : (
              filteredOrders.map((order, idx) => {
                const tier = order.customer_tier || "A_plus";
                const tierColor = { A_plus: "#3B82F6", C_plus: "#0891B2", B_plus: "#F59E0B" }[tier] || "#3B82F6";
                // Picklist state: red = not yet in a printed pick-list,
                // green = already printed for the warehouse. Only relevant
                // in the confirmed-orders tab.
                const isPicked = Boolean(order.picklist_printed_at);
                const inPicklistMode = (activeTab === "orders-confirmed" || activeTab === "orders") && picklistSelectMode;
                const isSelected = picklistSelectedIds.includes(order.id);
                let rowBg = idx % 2 === 0 ? "bg-white" : "bg-[#F8FAFC]";
                if (activeTab === "orders-confirmed") {
                  rowBg = isPicked
                    ? "bg-[#DCFCE7] hover:bg-[#BBF7D0]"
                    : "bg-[#FEE2E2] hover:bg-[#FECACA]";
                  if (isSelected) rowBg = "bg-[#FEF08A] hover:bg-[#FDE68A]";
                }
                const dt = (order.created_at || "").slice(0, 10);
                return (
                  <div
                    key={order.id}
                    data-testid={`compact-row-${order.id}`}
                    onClick={() => {
                      if (inPicklistMode) {
                        togglePicklistId(order.id);
                        return;
                      }
                      setCompactDetailOrderId(order.id);
                      setOrdersView("cards");
                      setTimeout(() => {
                        const el = document.querySelector(`[data-testid="admin-order-${order.id}"]`);
                        if (el) {
                          el.scrollIntoView({ behavior: "smooth", block: "center" });
                          el.classList.add("ring-4", "ring-[#F5A623]");
                          setTimeout(() => el.classList.remove("ring-4", "ring-[#F5A623]"), 2200);
                        }
                      }, 300);
                    }}
                    className={`grid ${inPicklistMode ? "grid-cols-[28px_40px_80px_110px_1fr_50px]" : "grid-cols-[40px_80px_110px_1fr_50px]"} gap-2 px-3 py-2 ${rowBg} border-b border-[#E4EBE6] text-sm cursor-pointer items-center transition-colors`}
                  >
                    {inPicklistMode && (
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => togglePicklistId(order.id)}
                        onClick={(e) => e.stopPropagation()}
                        data-testid={`picklist-check-${order.id}`}
                        className="w-4 h-4 accent-[#7C3AED] cursor-pointer"
                      />
                    )}
                    <span className="text-center text-[#5C6E64] tabular-nums" dir="ltr">{idx + 1}</span>
                    <span className="text-center font-black text-[#1E3A5F] tabular-nums" dir="ltr">#{order.invoice_number || order.id.slice(0, 6)}</span>
                    <span className="text-center text-xs text-[#5C6E64] tabular-nums" dir="ltr">{dt}</span>
                    <span className="font-bold text-[#111814] truncate flex items-center gap-1.5">
                      <span
                        className="inline-block w-2 h-2 rounded-full shrink-0"
                        style={{ background: tierColor }}
                        title={tier.replace("_", "+")}
                      />
                      {order.market_name || order.user_name || "—"}
                      {activeTab === "orders-confirmed" && isPicked && (
                        <span className="text-[9px] font-black text-[#15803D]" title="مطبوعة بقائمة تجهيز">✓ جُهّزت</span>
                      )}
                    </span>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setCompactDetailOrderId(order.id);
                        setOrdersView("cards");
                        setTimeout(() => {
                          const el = document.querySelector(`[data-testid="admin-order-${order.id}"]`);
                          if (el) {
                            el.scrollIntoView({ behavior: "smooth", block: "center" });
                            el.classList.add("ring-4", "ring-[#F5A623]");
                            setTimeout(() => el.classList.remove("ring-4", "ring-[#F5A623]"), 2200);
                          }
                        }, 300);
                      }}
                      data-testid={`compact-edit-${order.id}`}
                      className="bg-[#F5A623]/15 hover:bg-[#F5A623]/30 text-[#F59E0B] rounded-lg p-1.5 mx-auto flex items-center justify-center transition-colors"
                      title="عرض / تعديل الفاتورة الكاملة"
                    >
                      <Edit3 className="w-4 h-4" />
                    </button>
                  </div>
                );
              })
            )}
            <div className="bg-[#F8FAFC] px-3 py-2 text-xs text-[#5C6E64] flex justify-between items-center">
              <span><b dir="ltr">{filteredOrders.length}</b> فاتورة</span>
              <span>اضغط على أي صف ↑ لعرض الفاتورة الكاملة بالتفاصيل</span>
            </div>
          </div>
        ) : (
        /* Orders List — grid (3 per row on lg, 2 on md, 1 on mobile) */
        <div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 items-start"
          data-testid="admin-orders-list"
        >
          {filteredOrders.length === 0 ? (
            <div className="col-span-full text-center py-12 bg-white rounded-2xl border border-[#E4EBE6]">
              <Package className="w-16 h-16 text-[#E4EBE6] mx-auto mb-3" />
              <p className="text-[#5C6E64]">لا توجد طلبات</p>
            </div>
          ) : (
            filteredOrders.map((order, idx) => {
              const StatusIcon = statusConfig[order.status]?.icon || Clock;
              const statusColor = statusConfig[order.status]?.color;
              return (
                <motion.div
                  key={order.id}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.03 }}
                  data-testid={`admin-order-${order.id}`}
                  className="order-card-dark border-2 rounded-3xl p-6 space-y-5 shadow-2xl text-base"
                >
                  {/* Order Header */}
                  <div className="flex justify-between items-start flex-wrap gap-2">
                    <div className="flex items-center gap-3">
                      {/* Customer tier badge — pinned to the LEFT of the order
                          number so admin can spot A+/B+/C+ buyers at a glance.
                          Colour matches the tier (blue/grey/gold). */}
                      {(() => {
                        const t = order.customer_tier || "A_plus";
                        const meta = {
                          A_plus: { bg: "linear-gradient(135deg,#3B82F6 0%,#1E3A5F 100%)", label: "A+" },
                          C_plus: { bg: "linear-gradient(135deg,#475569 0%,#1f2937 100%)", label: "C+" },
                          B_plus: { bg: "linear-gradient(135deg,#F59E0B 0%,#92400E 100%)", label: "B+" },
                        }[t] || { bg: "#3B82F6", label: "A+" };
                        return (
                          <div
                            data-testid={`order-tier-badge-${order.id}`}
                            data-tier={t}
                            title={`تصنيف الزبون: ${meta.label}`}
                            className="rounded-2xl px-3 py-2 text-white font-extrabold text-base shadow-md border-2 border-white/30 min-w-[44px] text-center"
                            style={{ background: meta.bg }}
                          >
                            {meta.label}
                          </div>
                        );
                      })()}
                      <div className="bg-[#1E3A5F] text-white rounded-2xl px-4 py-2 shadow-md text-center min-w-[60px]">
                        <p className="text-[10px] opacity-80">رقم الطلب</p>
                        <p className="font-black text-2xl leading-none" dir="ltr">{order.__seq}</p>
                      </div>
                      <div className="text-xs text-[#5C6E64]" dir="ltr">
                        <p>#{(order.id || "").slice(0, 8).toUpperCase()}</p>
                        <p className="mt-0.5">{(order.created_at || "").replace("T", " ").slice(0, 16)}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2 flex-shrink-0">
                      <span
                        className="px-3 py-1.5 rounded-full text-xs font-bold flex items-center gap-1.5"
                        style={{
                          backgroundColor: `${statusColor}20`,
                          color: statusColor,
                        }}
                      >
                        <StatusIcon className="w-3 h-3" />
                        {statusConfig[order.status]?.label}
                      </span>
                      {/* Sky-blue notes button — opens the customer's note. Only
                          rendered when the order actually has a note. */}
                      {order.notes && order.notes.trim() && (
                        <button
                          type="button"
                          onClick={() => setOpenNoteOrderId(openNoteOrderId === order.id ? null : order.id)}
                          data-testid={`order-note-btn-${order.id}`}
                          data-keep-color="true"
                          title="ملاحظة الزبون"
                          aria-label="ملاحظة الزبون"
                          className="rounded-full w-8 h-8 flex items-center justify-center shadow-md border-2 border-white"
                          style={{ backgroundColor: "#0EA5E9" }}
                        >
                          <StickyNote className="w-4 h-4" style={{ color: "#FFFFFF" }} />
                        </button>
                      )}
                      {/* Quick-cancel ❌ — restores stock, removes profit, refunds debt */}
                      {order.status !== "rejected" && (
                        <button
                          type="button"
                          onClick={() => cancelOrder(order)}
                          data-testid={`order-quick-cancel-${order.id}`}
                          data-keep-color="true"
                          title="إلغاء الطلب وإرجاع الكميات"
                          aria-label="إلغاء الطلب"
                          className="bg-[#E85D45] hover:bg-[#d54d35] text-white rounded-full w-8 h-8 flex items-center justify-center shadow-md border-2 border-white"
                        >
                          <X className="w-4 h-4" strokeWidth={3} />
                        </button>
                      )}
                    </div>
                  </div>

                  {/* Customer Info — Colored Badge Cards */}
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                    {(order.is_supervisor_sale || order.supervisor_name) && (
                      <div
                        className="bg-gradient-to-l from-[#F5A623] to-[#E85D45] text-white rounded-2xl p-3 shadow-md md:col-span-3 ring-2 ring-white/20"
                        data-testid="badge-supervisor"
                      >
                        <p className="text-xs opacity-90 mb-1">{order.seller_role === "mandoob" ? "🧑‍💼 فاتورة من قبل المندوب" : "🛡️ طلب بيع مباشر من المشرف"}</p>
                        <p className="font-black text-base leading-tight">{order.supervisor_name || "—"}</p>
                      </div>
                    )}
                    <div
                      className="bg-gradient-to-l from-[#1E3A5F] to-[#3B82F6] text-white rounded-2xl p-4 shadow-md cursor-pointer hover:shadow-xl active:scale-95 transition-all md:col-span-2 ring-2 ring-white/20"
                      data-testid="badge-customer-name"
                      onClick={() => setHistoryQuery({ initial: order.user_phone || order.user_name })}
                      title="اضغط لعرض كل فواتير هذا الزبون"
                    >
                      <p className="text-xs opacity-90 mb-1">👤 اسم الزبون · انقر للسجل</p>
                      <p className="font-black text-xl leading-tight truncate">{order.user_name}</p>
                    </div>
                    {order.customer_id && (
                      <div className="bg-[#F5A623] text-white rounded-2xl p-3 shadow-sm flex flex-col justify-center">
                        <p className="text-[11px] opacity-90">رقم الايباد</p>
                        <p className="font-mono font-black text-2xl leading-tight" dir="ltr">{order.customer_id}</p>
                      </div>
                    )}
                    {order.market_name && (
                      <div className="bg-gradient-to-l from-[#15803d] to-[#7ED321] text-white rounded-2xl p-4 shadow-md md:col-span-2 ring-2 ring-white/20">
                        <p className="text-xs opacity-90 mb-1">🏪 اسم الماركت</p>
                        <p className="font-black text-xl leading-tight truncate">{order.market_name}</p>
                      </div>
                    )}
                    <a href={`tel:${order.user_phone}`} className="bg-[#E85D45] text-white rounded-2xl p-3 shadow-sm hover:bg-[#c14a36] flex flex-col justify-center">
                      <p className="text-[11px] opacity-90">📞 الموبايل</p>
                      <p className="font-mono font-bold text-base" dir="ltr">{order.user_phone}</p>
                    </a>
                    <div className="bg-[#3B82F6] text-white rounded-2xl p-3 shadow-sm col-span-2 md:col-span-1">
                      <p className="text-[11px] opacity-90">📍 العنوان</p>
                      <p className="font-medium text-sm leading-snug">{order.address || "—"}</p>
                    </div>
                    {order.driver_name && (
                      <div className="bg-[#9F7AEA] text-white rounded-2xl p-3 shadow-sm" data-testid="badge-driver">
                        <p className="text-[11px] opacity-90">🚚 السائق المعيّن</p>
                        <p className="font-bold text-base">{order.driver_name}</p>
                      </div>
                    )}
                    {order.mujahez_name && (
                      <div className="bg-[#0EA5E9] text-white rounded-2xl p-3 shadow-sm">
                        <p className="text-[11px] opacity-90">📦 المجهّز</p>
                        <p className="font-bold text-base">{order.mujahez_name}</p>
                      </div>
                    )}
                  </div>

                  {/* Cash collected info (only when delivered) */}
                  {order.amount_paid !== undefined && order.status === "delivered" && (
                    <div className="bg-white border border-[#E4EBE6] rounded-xl p-2.5 flex justify-between text-xs">
                      <span>المحصّل: <span className="font-bold text-[#7ED321]" dir="ltr">{Number(order.amount_paid).toLocaleString("en-US")} د.ع</span></span>
                      {order.amount_remaining > 0 && (
                        <span>الدين: <span className="font-bold text-[#E85D45]" dir="ltr">{Number(order.amount_remaining).toLocaleString("en-US")} د.ع</span></span>
                      )}
                    </div>
                  )}

                  {order.notes && openNoteOrderId === order.id && (
                    <div
                      className="rounded-xl p-3"
                      style={{ background: "rgba(14,165,233,0.12)", border: "2px solid #0EA5E9" }}
                      data-testid={`order-note-panel-${order.id}`}
                    >
                      <p className="text-xs font-bold mb-1 flex items-center gap-1" style={{ color: "#0EA5E9" }}>
                        <StickyNote className="w-3.5 h-3.5" style={{ color: "#0EA5E9" }} />
                        ملاحظة الزبون
                      </p>
                      <p className="text-sm" style={{ color: "#FFFFFF" }}>{order.notes}</p>
                    </div>
                  )}

                  {/* Items */}
                  <div className="bg-white rounded-xl p-3 space-y-1 border border-[#E4EBE6]">
                    <p className="text-xs font-bold text-[#1E3A5F] mb-2 border-b border-[#E4EBE6] pb-1">📦 المنتجات — اضغط السعر أو الكمية للتعديل (حتى بعد التسليم)</p>
                    {order.items.map((item) => {
                      const isEditingPrice =
                        editingOrderItem?.orderId === order.id &&
                        editingOrderItem?.productId === item.product_id;
                      const isEditingQty =
                        editingOrderItemQty?.orderId === order.id &&
                        editingOrderItemQty?.productId === item.product_id;
                      // Order items are editable for any status EXCEPT rejected.
                      // (User requested: edit invoice prices even after delivery
                      // so a typo can be fixed and the invoice re-printed.)
                      const editable = order.status !== "rejected";
                      // Look up cost price from current inventory (for tooltip + warning visuals)
                      const invProd = products.find((p) => p.id === item.product_id);
                      const itemCost = Number(invProd?.cost_price || item.cost_price || 0);
                      const invStock = Number(invProd?.stock || 0);
                      const belowCost = itemCost > 0 && Number(item.price || 0) < itemCost;
                      return (
                        <div key={item.product_id} className="flex justify-between items-center text-sm gap-2 py-1">
                          <span
                            className="text-[#111814] flex-1 truncate font-medium flex items-center gap-1.5 cursor-help"
                            title={`💰 سعر الشراء: ${Number(itemCost).toLocaleString("en-US")} د.ع · 🏬 المخزون المتوفر: ${invStock}${belowCost ? "\n⚠️ سعر البيع أقل من سعر الشراء!" : ""}`}
                            data-testid={`order-item-name-${order.id}-${item.product_id}`}
                          >
                            {belowCost && <span className="text-[#E85D45]" title="أقل من سعر الشراء">⚠️</span>}
                            {item.name_ar}
                          </span>

                          {/* Quantity */}
                          {isEditingQty ? (
                            <div className="flex items-center gap-1">
                              <input
                                type="number"
                                min="1"
                                step="1"
                                value={editItemQty}
                                onChange={(e) => setEditItemQty(e.target.value)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") { e.preventDefault(); handleSaveOrderItemQty(order.id, item.product_id); }
                                  else if (e.key === "Escape") { e.preventDefault(); setEditingOrderItemQty(null); setEditItemQty(""); }
                                }}
                                data-testid={`order-item-qty-input-${order.id}-${item.product_id}`}
                                className="w-16 px-2 py-1 rounded-lg border border-[#3B82F6] text-sm text-center bg-white"
                                autoFocus
                                dir="ltr"
                              />
                              <button
                                onClick={() => handleSaveOrderItemQty(order.id, item.product_id)}
                                data-testid={`order-item-qty-save-${order.id}-${item.product_id}`}
                                className="p-1.5 bg-[#7ED321] hover:bg-[#6cb91d] text-white rounded-lg"
                                title="حفظ الكمية"
                              >
                                <Save className="w-3.5 h-3.5" />
                              </button>
                              <button
                                onClick={() => { setEditingOrderItemQty(null); setEditItemQty(""); }}
                                className="p-1.5 bg-[#F3F6F4] text-[#5C6E64] rounded-lg"
                              >
                                <X className="w-3.5 h-3.5" />
                              </button>
                            </div>
                          ) : (
                            <button
                              onClick={() => {
                                if (!editable) return;
                                setEditingOrderItemQty({ orderId: order.id, productId: item.product_id });
                                setEditItemQty(String(item.quantity));
                                setEditingOrderItem(null);
                              }}
                              disabled={!editable}
                              data-testid={`order-item-qty-btn-${order.id}-${item.product_id}`}
                              className={`min-w-[40px] text-center font-bold ${editable ? "hover:bg-[#F0F9FF] px-2 py-1 rounded-lg text-[#1E3A5F] flex items-center gap-1" : "text-[#1E3A5F] cursor-default"}`}
                              dir="ltr"
                              title={editable ? "اضغط لتعديل الكمية" : "—"}
                            >
                              × {item.quantity}
                              {editable && <Edit3 className="w-3 h-3 text-[#5C6E64]" />}
                            </button>
                          )}

                          {/* Price (line total) */}
                          {isEditingPrice ? (
                            <div className="flex items-center gap-1">
                              <input
                                type="number"
                                min="0"
                                step="50"
                                value={editItemPrice}
                                onChange={(e) => setEditItemPrice(e.target.value)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") { e.preventDefault(); handleSaveOrderItemPrice(order.id, item.product_id); }
                                  else if (e.key === "Escape") { e.preventDefault(); setEditingOrderItem(null); setEditItemPrice(""); }
                                }}
                                data-testid={`order-item-price-input-${order.id}-${item.product_id}`}
                                className="w-24 px-2 py-1 rounded-lg border border-[#3B82F6] text-sm text-left bg-white"
                                autoFocus
                                dir="ltr"
                              />
                              <button
                                onClick={() => handleSaveOrderItemPrice(order.id, item.product_id)}
                                data-testid={`order-item-price-save-${order.id}-${item.product_id}`}
                                className="p-1.5 bg-[#7ED321] hover:bg-[#6cb91d] text-white rounded-lg"
                                title="حفظ السعر"
                              >
                                <Save className="w-3.5 h-3.5" />
                              </button>
                              <button
                                onClick={() => { setEditingOrderItem(null); setEditItemPrice(""); }}
                                className="p-1.5 bg-[#F3F6F4] text-[#5C6E64] rounded-lg"
                              >
                                <X className="w-3.5 h-3.5" />
                              </button>
                            </div>
                          ) : (
                            <button
                              onClick={() => {
                                if (!editable) return;
                                setEditingOrderItem({ orderId: order.id, productId: item.product_id });
                                setEditItemPrice(String(item.price));
                                setEditingOrderItemQty(null);
                              }}
                              disabled={!editable}
                              data-testid={`order-item-price-btn-${order.id}-${item.product_id}`}
                              className={`font-bold text-[#1E3A5F] flex items-center gap-1 ${editable ? "hover:bg-[#F0F9FF] px-2 py-1 rounded-lg" : "cursor-default"}`}
                              dir="ltr"
                              title={editable ? "اضغط لتعديل سعر الوحدة" : "—"}
                            >
                              {(item.price * item.quantity).toLocaleString("en-US", { maximumFractionDigits: 0 })} د.ع
                              {editable && <Edit3 className="w-3 h-3 text-[#5C6E64]" />}
                            </button>
                          )}
                        </div>
                      );
                    })}
                    <div className="flex justify-between items-center pt-2 mt-2 border-t border-[#E4EBE6]">
                      <span className="font-bold text-[#111814]">المجموع</span>
                      <span className="font-black text-xl text-[#E85D45]" dir="ltr">
                        {order.total.toLocaleString("en-US", { maximumFractionDigits: 0 })} د.ع
                      </span>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="flex flex-wrap gap-2 pt-2">
                    {/* Supervisor-invoice admin confirmation button —
                        shows ONLY when the invoice is still waiting for
                        admin acknowledgment. Click to move it from the
                        Pending bucket to Confirmed Invoices. */}
                    {order.awaiting_admin_confirmation && order.is_supervisor_sale && (
                      <button
                        onClick={() => confirmSupervisorSale(order)}
                        data-testid={`confirm-sup-sale-${order.id}`}
                        title="موافقة الإدارة — تنقل الفاتورة من الغير مؤكدة إلى المؤكدة"
                        className="bg-[#15803D] hover:bg-[#126b32] text-white font-bold py-2 px-4 rounded-full text-sm transition-colors flex items-center justify-center gap-1 shadow"
                      >
                        ✓ موافقة الإدارة
                      </button>
                    )}
                    {/* Edit-items button is ALWAYS available — admin can fix
                        any invoice's items at any time, even on delivered or
                        rejected orders from weeks ago. */}
                    <button
                      onClick={() => setEditingOrderForItems(order)}
                      data-testid={`edit-items-${order.id}`}
                      title="تعديل الفاتورة (حذف/إضافة مواد)"
                      className="bg-[#F59E0B] hover:bg-[#d97706] text-white font-medium py-2 px-4 rounded-full text-sm transition-colors flex items-center justify-center gap-1"
                    >
                      📝 تعديل الفاتورة
                    </button>
                    {/* Permanent-delete button — always available so admin
                        can wipe any old order (delivered, rejected, etc.)
                        from the records without losing the customer. */}
                    {order.status !== "pending" && (
                      <>
                        {/* ✕ Hide-only: removes from board without touching
                            stock/debt. Stays searchable later. */}
                        {order.admin_hidden ? (
                          <button
                            onClick={async () => {
                              try {
                                await axios.patch(`${API}/admin/orders/${order.id}/unhide`);
                                toast.success("تم إرجاع الفاتورة للوحة");
                                fetchData();
                              } catch (e) { toast.error("فشل الإرجاع"); }
                            }}
                            data-testid={`unhide-order-${order.id}`}
                            title="إرجاع الفاتورة للوحة"
                            className="bg-[#10B981] hover:bg-[#059669] text-white font-medium py-2 px-4 rounded-full text-sm transition-colors flex items-center justify-center gap-1"
                          >
                            ↩ إرجاع للوحة
                          </button>
                        ) : (
                          <button
                            onClick={() => hideOrder(order)}
                            data-testid={`hide-order-${order.id}`}
                            title="إخفاء من اللوحة فقط — البضاعة لا ترجع للمخزن، تظل قابلة للبحث"
                            className="bg-[#9CA3AF] hover:bg-[#6B7280] text-white font-medium py-2 px-4 rounded-full text-sm transition-colors flex items-center justify-center gap-1"
                          >
                            ✕ إخفاء من اللوحة
                          </button>
                        )}
                        <button
                          onClick={() => permanentDeleteOrder(order)}
                          data-testid={`delete-order-${order.id}`}
                          title="حذف الطلب نهائياً من السجل (لن يحذف الزبون)"
                          className="bg-[#E85D45] hover:bg-[#cf4933] text-white font-medium py-2 px-4 rounded-full text-sm transition-colors flex items-center justify-center gap-1"
                        >
                          🗑️ حذف نهائي (إرجاع للمخزن)
                        </button>
                      </>
                    )}
                    {order.status === "pending" && (
                      <>
                        <button
                          onClick={() => setComboOrder(order)}
                          data-testid={`combo-action-${order.id}`}
                          title={order.printed_at
                            ? `مطبوعة ✅ — إجراء كامل: طباعة + تعيين سائق/مجهّز + تأكيد`
                            : "غير مطبوعة 🔴 — إجراء كامل: طباعة + تعيين سائق/مجهّز + تأكيد"}
                          className="w-full bg-gradient-to-l from-[#7e22ce] to-[#5b21b6] hover:opacity-90 text-white font-extrabold py-2 rounded-full text-sm transition-opacity flex items-center justify-center gap-2 mb-2"
                        >
                          <span
                            data-testid={`print-status-${order.id}`}
                            className={`w-2.5 h-2.5 rounded-full ring-2 ring-white/70 ${
                              order.printed_at
                                ? "bg-emerald-400 shadow-[0_0_6px_rgba(52,211,153,0.9)]"
                                : "bg-red-500 shadow-[0_0_6px_rgba(239,68,68,0.9)] animate-pulse"
                            }`}
                          />
                          ⚡ إجراء كامل (طباعة + تعيين + تأكيد)
                        </button>
                        <button
                          onClick={async () => {
                            await updateStatus(order.id, "confirmed");
                            setInvoiceOrder(order);
                          }}
                          data-testid={`confirm-${order.id}`}
                          className="flex-1 bg-[#4A90E2] hover:bg-[#3a7bc4] text-white font-medium py-2 rounded-full text-sm transition-colors"
                        >
                          ✓ تأكيد الطلب
                        </button>
                        <button
                          onClick={() => updateStatus(order.id, "rejected")}
                          data-testid={`reject-${order.id}`}
                          className="flex-1 bg-[#F3F6F4] hover:bg-[#E4EBE6] text-[#5C6E64] font-medium py-2 rounded-full text-sm transition-colors"
                        >
                          ✕ رفض
                        </button>
                        <button
                          onClick={() => permanentDeleteOrder(order)}
                          data-testid={`delete-order-${order.id}`}
                          title="حذف الطلب نهائياً من السجل (لن يحذف الزبون)"
                          className="flex items-center justify-center gap-1 bg-[#E85D45] hover:bg-[#cf4933] text-white font-medium py-2 px-3 rounded-full text-sm transition-colors"
                        >
                          🗑️ حذف
                        </button>
                      </>
                    )}
                    {/* Mujahez assign — opens a modal with mujahez picker
                        + OPTIONAL discount field (admin-only). Available
                        until order is rejected. */}
                    {availableMujahez.length > 0 && order.status !== "rejected" && (
                      <button
                        type="button"
                        onClick={() => {
                          setAssignModal({ orderId: order.id, orderTotal: order.total });
                          setAssignMujahezId(order.mujahez_id || "");
                          setAssignDiscount("");
                        }}
                        data-testid={`open-assign-mujahez-${order.id}`}
                        className="w-full mt-2 px-4 py-2 rounded-full bg-[#F0FDF4] border border-[#7ED321]/40 text-sm font-medium text-[#2D4A3E] hover:bg-[#DCFCE7] flex items-center justify-center gap-1 transition-colors"
                      >
                        📦 {order.mujahez_name ? `إعادة تعيين مجهّز (الحالي: ${order.mujahez_name})` : "تعيين مجهّز + خصم..."}
                      </button>
                    )}
                    {availableDrivers.length > 0 && order.status === "pending" && (
                      <select
                        data-testid={`assign-${order.id}`}
                        onChange={(e) => {
                          if (e.target.value) {
                            assignDriver(order.id, e.target.value);
                            e.target.value = "";
                          }
                        }}
                        value=""
                        className="w-full mt-2 px-4 py-2 rounded-full bg-[#E0F2FE] border border-[#4A90E2]/30 text-sm font-medium text-[#2D4A3E] focus:outline-none focus:ring-2 focus:ring-[#4A90E2]"
                      >
                        <option value="" disabled>🚚 تعيين سائق مباشرة (تخطي المجهّز)...</option>
                        {availableDrivers.map((d) => (
                          <option key={d.id} value={d.id}>
                            {d.full_name} ({d.active_orders} نشطة)
                          </option>
                        ))}
                      </select>
                    )}
                    {order.status === "confirmed" && (
                      <button
                        onClick={() => updateStatus(order.id, "delivering")}
                        data-testid={`deliver-${order.id}`}
                        className="flex-1 bg-[#E85D45] hover:bg-[#d54d35] text-white font-medium py-2 rounded-full text-sm transition-colors"
                      >
                        🚚 بدء التوصيل
                      </button>
                    )}
                    {order.status === "delivering" && (
                      <button
                        onClick={() => updateStatus(order.id, "delivered")}
                        data-testid={`complete-${order.id}`}
                        className="flex-1 bg-[#7ED321] hover:bg-[#6cb91d] text-white font-medium py-2 rounded-full text-sm transition-colors"
                      >
                        ✓ تم التوصيل
                      </button>
                    )}
                    {/* Print Invoice button — visible for non-pending/non-rejected.
                        The little dot (🟢 green | 🔴 red) reflects whether this
                        invoice has ever been printed via the admin dashboard.
                        Flips to green as soon as this button is clicked. */}
                    {!["pending", "rejected"].includes(order.status) && (
                      <button
                        onClick={() => setInvoiceOrder(order)}
                        data-testid={`print-invoice-${order.id}`}
                        className="bg-[#1E3A5F] hover:bg-[#152a45] text-white font-bold py-2 px-4 rounded-full text-sm transition-colors flex items-center gap-2 relative"
                        title={order.printed_at ? `مطبوعة ✅ (${order.print_count || 1} مرة)` : "غير مطبوعة — اضغط للطباعة"}
                      >
                        <span
                          data-testid={`print-status-${order.id}`}
                          className={`w-2.5 h-2.5 rounded-full ring-2 ring-white/70 ${
                            order.printed_at
                              ? "bg-emerald-400 shadow-[0_0_6px_rgba(52,211,153,0.9)]"
                              : "bg-red-500 shadow-[0_0_6px_rgba(239,68,68,0.9)] animate-pulse"
                          }`}
                          aria-label={order.printed_at ? "مطبوعة" : "غير مطبوعة"}
                        />
                        <Printer className="w-4 h-4" />
                        طباعة الفاتورة
                      </button>
                    )}
                  </div>
                </motion.div>
              );
            })
          )}
        </div>
        )}
        </>
        )}
            </div>
          </>
        )}
      </main>

      <ProductFormModal
        isOpen={showProductForm}
        onClose={() => {
          setShowProductForm(false);
          setProductToEdit(null);
          setPreselectedBrandForNew(null);
          setBulkAddMode(false);
        }}
        onSuccess={() => { fetchData(); fetchProductsBrands(); bumpProductsChanged(); }}
        categories={categories}
        editProduct={productToEdit}
        preselectedBrand={preselectedBrandForNew}
        keepOpenAfterSave={bulkAddMode}
      />

      {offersPickerBrand && (
        <BrandOffersPickerModal
          brand={offersPickerBrand}
          onClose={() => setOffersPickerBrand(null)}
          onSaved={() => fetchData()}
        />
      )}

      {lowStockBrand && (
        <LowStockAlertModal
          brand={lowStockBrand}
          onClose={() => setLowStockBrand(null)}
        />
      )}

      {historyQuery && (
        <CustomerHistoryModal
          initialQuery={historyQuery.initial || ""}
          onClose={() => { setHistoryQuery(null); fetchData(); }}
        />
      )}

      {tileImageEditor && (
        <TileImageEditor
          tileId={tileImageEditor.tile_id}
          label={tileImageEditor.label}
          current={tileImages[tileImageEditor.tile_id] || {}}
          onClose={() => setTileImageEditor(null)}
          onSaved={(next) => {
            setTileImages((prev) => ({ ...prev, [tileImageEditor.tile_id]: next }));
            setTileImageEditor(null);
          }}
        />
      )}

      {invoiceOrder && (
        <InvoiceModal
          order={invoiceOrder}
          customerInfo={{ customer_debt: invoiceCustomerDebt }}
          onClose={() => setInvoiceOrder(null)}
        />
      )}

      <OrderComboActionModal
        open={!!comboOrder}
        order={comboOrder}
        drivers={availableDrivers}
        mujahez={availableMujahez}
        onPrint={(o) => setInvoiceOrder(o)}
        onClose={() => setComboOrder(null)}
        onComplete={() => fetchData()}
      />

      {editingOrderForItems && (
        <OrderEditModal
          order={editingOrderForItems}
          onClose={() => setEditingOrderForItems(null)}
          onSaved={() => { fetchData(); }}
        />
      )}

      {showLowStock && (
        <LowStockModal
          onClose={() => setShowLowStock(false)}
          onDone={(list) => {
            if (list && list.length) {
              setPurchasePresetProductIds(list.map((p) => p.id));
              setActiveTab("purchase");
              setShowTileMenu(false);
            }
          }}
        />
      )}

      {/* Group Submenu Modal — opens when an orange parent tile is clicked */}
      {activeGroupId && (() => {
        const g = VISIBLE_GROUPS.find((x) => x.id === activeGroupId);
        if (!g) return null;
        const children = g.children
          .map((cid) => ADMIN_TILES.find((t) => t.id === cid))
          .filter(Boolean);
        return (
          <div
            className="fixed inset-0 z-[130] bg-black/70 flex items-end sm:items-center justify-center p-0 sm:p-3"
            onClick={() => setActiveGroupId(null)}
            data-testid={`group-modal-${g.id}`}
            dir="rtl"
          >
            {/* Mobile: bottom-sheet full-width, flex column so the header
                is fixed and only the body scrolls (no more clipping
                bug on Android that was hiding the lower tiles). */}
            <div
              className="bg-white rounded-t-3xl sm:rounded-3xl w-full max-w-2xl h-[85vh] sm:h-auto sm:max-h-[85vh] shadow-2xl flex flex-col overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              <div
                style={{ background: `linear-gradient(to left, ${g.color}, #dc9320)` }}
                className="text-white p-3 sm:p-4 flex items-center justify-between shrink-0"
              >
                <div className="flex items-center gap-2 min-w-0">
                  <g.icon className="w-5 h-5 sm:w-6 sm:h-6 shrink-0" />
                  <div className="min-w-0">
                    <h3 className="font-bold text-base sm:text-lg truncate">{g.label}</h3>
                    <p className="text-[10px] opacity-90">{g.children.length} أقسام · اختر القسم الذي تريد</p>
                  </div>
                </div>
                <button
                  onClick={() => setActiveGroupId(null)}
                  data-testid={`group-close-${g.id}`}
                  className="bg-white/20 hover:bg-white/30 rounded-full p-1.5 shrink-0"
                >
                  <span className="text-lg leading-none">✕</span>
                </button>
              </div>
              <div
                className="flex-1 min-h-0 overflow-y-auto p-2 sm:p-4 pb-6"
                style={{ WebkitOverflowScrolling: "touch" }}
              >
                <div className="grid grid-cols-3 sm:grid-cols-3 gap-2 sm:gap-3">
                {children.map((tile) => (
                  <button
                    key={tile.id}
                    onClick={() => {
                      setActiveTab(tile.id);
                      setActiveGroupId(null);
                      setShowTileMenu(false);
                    }}
                    data-testid={`group-child-${tile.id}`}
                    className="relative bg-gradient-to-l from-[#1E3A5F] to-[#3B82F6] hover:from-[#152a45] hover:to-[#2563EB] text-white rounded-2xl shadow-md hover:shadow-xl transition-all p-2 sm:p-4 flex flex-col items-center gap-1 sm:gap-2 min-h-[78px] sm:min-h-[100px] hover:-translate-y-1"
                  >
                    <tile.icon className="w-5 h-5 sm:w-7 sm:h-7" strokeWidth={1.8} />
                    <span className="font-bold text-[11px] sm:text-sm text-center leading-tight line-clamp-2">{tile.label}</span>
                    {tile.badge && tile.badge(badges) > 0 && (
                      <span className="absolute top-1 left-1 sm:top-1.5 sm:left-1.5 bg-[#F5A623] text-[#111814] text-[9px] sm:text-[10px] font-black w-5 h-5 sm:w-6 sm:h-6 rounded-full flex items-center justify-center animate-pulse">
                        {tile.badge(badges)}
                      </span>
                    )}
                  </button>
                ))}
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* Floating "back to manager" button — only shown when the HR manager
          is peeking the full admin dashboard. */}
      {user?.is_employees_only && peekAdmin && (
        <button
          type="button"
          onClick={() => togglePeekAdmin(false)}
          data-testid="back-to-hr"
          title="رجوع لحساب المدير"
          className="fixed bottom-4 right-4 z-[180] bg-[#F5A623] hover:bg-[#e09418] text-white font-bold px-4 py-3 rounded-full shadow-2xl flex items-center gap-2 text-sm border-2 border-white"
        >
          <ArrowRight className="w-4 h-4" />
          رجوع لحساب المدير
        </button>
      )}

      {/* Pending-drafts confirm modal */}
      {draftsCtx.pendingTarget && (
        <div className="fixed inset-0 z-[200] bg-black/60 flex items-center justify-center p-3" dir="rtl" data-testid="draft-confirm-modal">
          <div className="bg-white rounded-3xl w-full max-w-sm overflow-hidden shadow-2xl">
            <div className="bg-gradient-to-l from-[#F59E0B] to-[#F97316] text-white p-4">
              <h3 className="font-bold text-lg">معلومات غير محفوظة</h3>
            </div>
            <div className="p-4 space-y-3 text-sm text-[#111814]">
              <p>
                هناك معلومات غير محفوظة في "
                <span className="font-bold text-[#1E3A5F]">{draftsCtx.drafts[draftsCtx.pendingTarget.from]?.label || draftsCtx.pendingTarget.from}</span>".
              </p>
              <p className="text-xs text-[#5C6E64]">
                إذا اخترت "إلغاء المعلومات" سيتم حذف كل ما كتبته. إذا اخترت "احتفاظ" سيبقى الشغل معلّقاً في الشريط بالأعلى وتقدر ترجعله بضغطة.
              </p>
            </div>
            <div className="p-3 border-t-2 border-[#E4EBE6] flex justify-end gap-2 flex-wrap">
              <button
                onClick={draftsCtx.cancelSwitch}
                data-testid="draft-confirm-back"
                className="bg-[#F3F6F4] hover:bg-[#E4EBE6] text-[#5C6E64] font-bold py-2 px-4 rounded-full text-sm"
              >
                رجوع
              </button>
              <button
                onClick={() => {
                  // Keep draft, switch tab anyway
                  if (!draftsCtx.pendingTarget) return;
                  const cb = draftsCtx.pendingTarget.onConfirm;
                  draftsCtx.setPendingTarget(null);
                  cb && cb();
                }}
                data-testid="draft-confirm-keep"
                className="bg-[#1E3A5F] hover:bg-[#152a45] text-white font-bold py-2 px-4 rounded-full text-sm"
              >
                احتفاظ + تبديل
              </button>
              <button
                onClick={draftsCtx.proceedSwitch}
                data-testid="draft-confirm-discard"
                className="bg-[#E85D45] hover:bg-[#d54d35] text-white font-bold py-2 px-4 rounded-full text-sm"
              >
                إلغاء المعلومات
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal close-confirm (for any modal with unsaved data) */}
      {draftsCtx.closeConfirm && (
        <div className="fixed inset-0 z-[210] bg-black/60 flex items-center justify-center p-3" dir="rtl" data-testid="modal-close-confirm">
          <div className="bg-white rounded-3xl w-full max-w-sm overflow-hidden shadow-2xl">
            <div className="bg-gradient-to-l from-[#E85D45] to-[#F97316] text-white p-4">
              <h3 className="font-bold text-lg">معلومات غير محفوظة</h3>
            </div>
            <div className="p-4 space-y-2 text-sm text-[#111814]">
              <p>
                هل تريد إلغاء البيانات التي كتبتها في "
                <span className="font-bold text-[#1E3A5F]">{draftsCtx.closeConfirm.label}</span>"؟
              </p>
              <p className="text-xs text-[#5C6E64]">إذا اخترت "رجوع" يبقى النموذج مفتوحاً وتقدر تكمل الإدخال.</p>
            </div>
            <div className="p-3 border-t-2 border-[#E4EBE6] flex justify-end gap-2">
              <button
                onClick={() => draftsCtx.resolveClose(false)}
                data-testid="modal-close-back"
                className="bg-[#F3F6F4] hover:bg-[#E4EBE6] text-[#5C6E64] font-bold py-2 px-4 rounded-full text-sm"
              >
                رجوع
              </button>
              <button
                onClick={() => draftsCtx.resolveClose(true)}
                data-testid="modal-close-discard"
                className="bg-[#E85D45] hover:bg-[#d54d35] text-white font-bold py-2 px-4 rounded-full text-sm"
              >
                إلغاء البيانات
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ─── Assign-Mujahez Modal (admin-only) ─────────────────────────
          Picks the mujahez to handle the order + lets the admin apply a
          one-time خصم on the invoice. The discount reduces order total,
          customer debt, AND app profit. Feb 14, 2026. */}
      {assignModal && (
        <div
          className="fixed inset-0 z-[140] bg-black/60 flex items-center justify-center p-3"
          onClick={() => setAssignModal(null)}
          data-testid="assign-mujahez-modal"
          dir="rtl"
        >
          <div
            className="bg-white rounded-3xl w-full max-w-md shadow-2xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bg-gradient-to-l from-[#15803D] to-[#7ED321] text-white p-4 flex justify-between items-center">
              <div>
                <h3 className="font-black text-lg">📦 تعيين مجهّز + خصم</h3>
                <p className="text-[10px] opacity-90 mt-0.5">
                  الفاتورة:{" "}
                  <span dir="ltr" className="font-bold">
                    {Number(assignModal.orderTotal || 0).toLocaleString("en-US")} د.ع
                  </span>
                </p>
              </div>
              <button
                onClick={() => setAssignModal(null)}
                data-testid="assign-mujahez-modal-close"
                className="bg-white/20 hover:bg-white/30 rounded-full p-1.5"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="p-4 space-y-3">
              <div>
                <label className="text-xs text-[#5C6E64] block mb-1 font-bold">
                  المجهّز المسؤول *
                </label>
                <select
                  value={assignMujahezId}
                  onChange={(e) => setAssignMujahezId(e.target.value)}
                  data-testid="assign-mujahez-select"
                  className="w-full px-3 py-2.5 rounded-xl border-2 border-[#7ED321]/40 bg-white text-sm focus:outline-none focus:border-[#7ED321]"
                >
                  <option value="" disabled>اختر المجهّز...</option>
                  {(availableMujahez || []).map((m) => (
                    <option key={m.id} value={m.id}>
                      {m.full_name} ({m.pending_count} بانتظار)
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="text-xs text-[#5C6E64] block mb-1 font-bold flex items-center gap-1">
                  💰 خصم على الفاتورة (اختياري)
                  <span className="text-[10px] font-normal text-[#5C6E64]/70">
                    — يقلّل الإجمالي والدين والربح
                  </span>
                </label>
                <div className="relative">
                  <input
                    type="number"
                    inputMode="numeric"
                    min={0}
                    max={assignModal.orderTotal || undefined}
                    value={assignDiscount}
                    onChange={(e) => setAssignDiscount(e.target.value)}
                    placeholder="مثلاً: 5000"
                    data-testid="assign-discount-input"
                    dir="ltr"
                    className="w-full px-3 py-2.5 rounded-xl border-2 border-[#F59E0B]/40 bg-[#FFFBEB] text-base font-bold text-center focus:outline-none focus:border-[#F59E0B]"
                  />
                  <span className="absolute left-3 top-1/2 -translate-y-1/2 text-xs text-[#5C6E64]">
                    د.ع
                  </span>
                </div>
                {parseFloat(assignDiscount) > 0 && (
                  <div className="mt-2 bg-[#ECFDF5] border border-[#22C55E]/30 rounded-xl p-2 text-[11px] text-[#065F46]">
                    <p>
                      الإجمالي بعد الخصم:{" "}
                      <span dir="ltr" className="font-black">
                        {Math.max(
                          0,
                          (assignModal.orderTotal || 0) - (parseFloat(assignDiscount) || 0)
                        ).toLocaleString("en-US")}{" "}
                        د.ع
                      </span>
                    </p>
                    <p className="opacity-80 mt-0.5">
                      📉 الربح ينقص بـ{" "}
                      <span dir="ltr">
                        {Number(parseFloat(assignDiscount) || 0).toLocaleString("en-US")} د.ع
                      </span>{" "}
                      — الزبون يدفع أقل.
                    </p>
                  </div>
                )}
              </div>
              <p className="text-[10px] text-[#5C6E64] bg-[#F8FAFC] rounded-xl p-2">
                🔒 الخصم متاح فقط للأدمن — لا يظهر للمجهّز ولا للسائق. سيُسجَّل في
                الحركة اليومية ويظهر سطر "خصم" عند طباعة الفاتورة.
              </p>
            </div>
            <div className="p-3 border-t-2 border-[#E4EBE6] flex justify-end gap-2">
              <button
                onClick={() => setAssignModal(null)}
                data-testid="assign-mujahez-cancel"
                className="bg-[#F3F6F4] hover:bg-[#E4EBE6] text-[#5C6E64] font-bold py-2 px-4 rounded-full"
              >
                إلغاء
              </button>
              <button
                onClick={submitAssignModal}
                data-testid="assign-mujahez-submit"
                className="bg-[#15803D] hover:bg-[#0f6630] text-white font-bold py-2 px-5 rounded-full flex items-center gap-1"
              >
                ✓ تعيين
                {parseFloat(assignDiscount) > 0 && " + خصم"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showMasterProfile && (
        <MasterProfileModal
          user={user}
          onClose={() => setShowMasterProfile(false)}
          onSaved={() => refreshUser?.()}
        />
      )}

      {showWelcomeSplash && (
        <WelcomeSplash user={user} onDone={() => { setShowWelcomeSplash(false); setIconsRevealed(true); }} />
      )}

      <MonthlyNetProfitModal
        open={showMonthlyNetProfit}
        onClose={() => setShowMonthlyNetProfit(false)}
      />

    </div>
  );
};

export default Admin;
